import React, { Component, useState } from "react";
import Tooltip from "../../components/UI/TooltipIcon/TooptipIcon";
import size from "lodash/size";
import { withRouter } from "react-router-dom";
import Checkbox from "rc-checkbox";
import { Alert, Progress } from "reactstrap";
import CalendarAdd from "./CalendarAdd";
import moment from "moment";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  Label,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Row,
  Col,
  Table,
  Input,
} from "reactstrap";
import { connect } from "react-redux";
import CKEditorUI from "../../components/CKEditor/CKEditorUI";
import DatePicker from "react-datepicker";
import isEmpty from "lodash/isEmpty";
import { inRange } from "lodash";
import UploadFileIcon from "../../assets/officeIcons/file-upload.svg";
import UserIcon1 from "../../assets/user-image-plc/User_Icon_1.svg";
import UserIcon2 from "../../assets/user-image-plc/User_Icon_2.svg";
import analyticsIcon from "../../assets/placeholders/analytics.png";
import PriorityContainer from "../../components/PriorityContainer/PriorityContainer";
import {
  BiArrowBack,
  BiArrowFromRight,
  BiCheck,
  BiDotsVertical,
  BiLink,
  BiUserPlus,
  BiLock,
} from "react-icons/bi";
import "rc-checkbox/assets/index.css";
import Loading from "../../hoc/Loading/Loading";
import Toggle from "react-toggle";
import axios from "../../axios";
import * as url from "../../utils/url";
import {
  taskValidation,
  isUserRemoved,
  storyTemplates,
  checkUploadType,
  uploadPreview,
  staticTitles,
  grpBannerImg,
  task_priority,
  privacyMap,
  checkValidityForAnonymousToggleEdit,
  renderGenderPronoun,
  NO_CONTENT_MESSAGE,
  privacy_options,
} from "../../utils/constants";
import ReactTooltip from "react-tooltip";
import reverse from "lodash/reverse";
import sortBy from "lodash/sortBy";
import findIndex from "lodash/findIndex";
import * as actionCreators from "../../modules/actions/index";
import filter from "lodash/filter";
import LinkedCharts from "./LinkedCharts";
import LinkedTools from "./LinkedTools";
import TaskFileUploads from "./TaskFileUploads";
import AddToGroup from "../../components/AddToGroup/AddToGroup.jsx";
import { array } from "prop-types";
import noLinkedChart from "../../assets/onboarding/analytics.png";
import noLinkedTools from "../../assets/onboarding/toolkit.png";
import noAttachments from "../../assets/upload_file.svg";
import {
  BiBasket,
  BiChart,
  BiFileFind,
  BiReceipt,
  BiX,
  BiChevronLeft,
} from "react-icons/bi";
import { isMobile } from "../../utils/deviceInfo";
import AssigneeDropdown from "./AssigneeDropdown";
import TaskActivity from "./TaskActivity";
import SubActionsTab from "./SubActionsTab";
import {
  capitalizeFirstLetter,
  capitalizeFirstLetterOtherSmall,
} from "../../utils/stringUtils";
import ShareEntity from "../../components/ShareEntity/ShareEntity";
import { toastContainer } from "../../utils/toast";
import Select from "react-select/lib/Select";

class SingleTask extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAnonymousVisible: false,
      optionsDropdownOpen: false,
      task: {},
      isArchived: false,
      task_copy: {},
      percentComplete: null,
      users: [],
      formData: [],
      rejectedFiles: [],
      isEditModal: false,
      isAssigned: false,
      uploadFileErr: "",
      isGroupModal: false,
      assignedUser: {},
      displayType: 1,
      tools: [],
      charts: [],
      updatedFields: [],
      removedFields: [],
      allItems: [],
      temp_name: "",
      isResourceSelect: null,
      isLinkItemsModal: false,
      errorSubmit: "",
      enterpriseObjectives: [],
      enterpriseObjectivesCopy: [],
      selectedObjective: {},
      displayItems: [],
      isActionsModal: false,
      isEObj: false,
      dropdownOpen: false,
      isAnonymous: false,
      isUploadFiles: false,
      linkedItems: [],
      attachedChartItems: [],
      attachedToolItems: [],
      searchedTerm: "",
      setImagesPreview: [],
      assigneeDropDownOpen: true,
      subActionId: null,
      showPublicAlert: false,
      showPrivateTasksEoAlert: false,
      showLinkObjAlert: false,
    };
    this.timer = null;
    this.box = React.createRef();
  }

  componentDidMount() {
    // console.log(this.props)
    // console.log('single task props!')
    // if(this.props.editModalId ){
    //   this.setState({
    //     task: this.props.selectedTask,
    //     task_copy: this.props.selectedTask,
    //   });
    //   let orgId = this.props.user.profile.organizationId._id;
    //   let id = this.props.editModalId;
    //   let userId = this.props.user.profile._id;

    //   this.retrieveTask(orgId, id, userId);
    // }else{
    //   let orgId = this.props.user.profile.organizationId._id;
    //   let id = this.props.match.params.id;
    //   let userId = this.props.user.profile._id;
    //   this.retrieveTask(orgId, id, userId);
    // }
    this.getTaskId();
    this.handleAssignUser("a");
    document.addEventListener("click", this.handleOutsideClick);
    let orgId = this.props.user.profile.organizationId._id;
    axios.get(url.findOrgById(orgId)).then(({ data }) => {
      const payload = data.data;
      this.props.orgChangeSuccess(payload);
    });
  }

  componentWillUnmount(){
    document.removeEventListener("click", this.handleOutsideClick);
  }

  handleOutsideClick = (event) => {
    if (
      this.box &&
      this.box.current &&
      !this.box.current.contains(event.target)
    ) {
      this.setState({ assigneeDropDownOpen: false });
    }
  };

  componentWillReceiveProps(nextProps) {
    console.log("RECC", this.props.editModalId, nextProps.editModalId);
    if (this.props.editModalId !== nextProps.editModalId) {
      this.getTaskId();
      //  let orgId = this.props.user.profile.organizationId._id;
      //  let id = this.props.editModalId;
      //  let userId = this.props.user.profile._id;

      //  this.retrieveTask(orgId, id, userId);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.subActionId !== this.state.subActionId) {
      let orgId = this.props.user.profile.organizationId._id;
      let id = this.state.subActionId;
      let userId = this.props.user.profile._id;

      this.retrieveTask(orgId, id, userId);
    }
  }

  getTaskId = () => {
    if (this.props.editModalId) {
      if (this.props.selectedTask) {
        this.setState({
          task: this.props.selectedTask,
          task_copy: this.props.selectedTask,
        });
      }

      let orgId = this.props.user.profile.organizationId._id;
      let id = this.props.editModalId;
      let userId = this.props.user.profile._id;

      this.retrieveTask(orgId, id, userId);
    } else {
      let orgId = this.props.user.profile.organizationId._id;
      let id = this.props.match.params.id;
      let userId = this.props.user.profile._id;
      this.retrieveTask(orgId, id, userId);
    }
  };

  retrieveTask = (orgId, id, userId) => {
    var that = this;
    let params = {
      orgId,
      task: id,
      userId,
    };
    if (!this.props.editModalId) {
      if (id == "undefined") {
        this.props.history.push("/home/my-activity");
        toastContainer(NO_CONTENT_MESSAGE, "error");
        return;
      }
    }
    axios
      .get(url.getSingleTask, {
        params: params,
      })
      .then((result) => {
        let task = result.data.data;

        if( (task.privacy ==1 || task.privacy == null || task.privacy==undefined || task.privacy=="PUBLIC" || !task.hasOwnProperty("privacy")) && task.parentTask && task.parentTask.item && task.parentTask.item._id){
          task.privacy = 2
        }

        const orgAdmin = this.props.user.profile.orgAdmin;
        let ObjArr = [];
        if (task.assignedTo && task.assignedTo._id) {
          ObjArr.push(task.assignedTo._id.toString());
        }

        if (task.userId && task.userId._id) {
          ObjArr.push(task.userId._id.toString());
        }
        const isCurrentUserAssigneeOrOwner =
          ObjArr.includes(this.props.user.profile._id) || orgAdmin;

        let renderUi = true;

        if (!this.props.editModalId) {
          if (isCurrentUserAssigneeOrOwner) {
            renderUi = true;
          } else {
            renderUi = false;
          }
        }

        if (renderUi) {
          const hideAnonymous =
            this.props.user.profile &&
            this.props.user.profile.organizationId.disableAnonymity
              ? checkValidityForAnonymousToggleEdit(
                  task.createdOn,
                  task.isAnonymous,
                  "planning",
                  this.props.user.profile.organizationId.disableAnonymity
                )
              : false;

          this.setState();
          const chartsIds = task.charts.map((item) => item.itemId);

          if (chartsIds.length) {
            let payload = {
              linkedCharts: chartsIds,
              taskId: task._id,
              category: "All",
            };
            axios
              .post(url.fetchAttachedCharts, payload)
              .then(({ data }) => {
                const res = data.data;
                const chartArr = task.charts.map((itm) => ({
                  ...itm,
                  chartData: { ...res.find((x) => x._id == itm.itemId) },
                }));

                this.setState({ charts: chartArr });
              })
              .catch((err) => console.log(err));
          }
          this.setState({
            task,
            task_copy: result.data.data,
            percentComplete:
              task.percentComplete &&
              task.percentComplete.length > 0 &&
              task.percentComplete[0].value
                ? task.percentComplete[0]
                : null,
            selectedObjective:
              task.parentTask && task.parentTask.item
                ? task.parentTask.item
                : {},
            charts:
              result.data.data.charts && result.data.data.charts.length > 0
                ? [...result.data.data.charts]
                : [],
            tools:
              result.data.data.tools && result.data.data.tools.length > 0
                ? [...result.data.data.tools]
                : [],
            isAnonymous: result.data.data.isAnonymous,
            isAnonymousVisible: !hideAnonymous,
          });
        } else {
          this.props.history.push("/home/my-activity");
          toastContainer("You are not authorized to view this action", "error");
        }
      })
      .catch((err) => {
        this.props.history.push("/home/my-activity");
        toastContainer(NO_CONTENT_MESSAGE, "error");
      });
  };

  navigateToEO = (id) => {
    this.props.history.push(`/home/enterprise-associatedActions/${id}`);
  };

  isEditModal = () => {
    let { isEditModal } = this.state;
    isEditModal = !isEditModal;
    this.setState({ isEditModal });
  };

  isDueDatePast = (todo) => {
    if (
      todo.isDeleted != true &&
      !todo.completedDate &&
      todo.dueDate &&
      todo.dueDate != null &&
      todo.dueDate != undefined &&
      moment(todo.dueDate).format("YYYY-MM-DD") < moment().format("YYYY-MM-DD")
    ) {
      return true;
    }
    return false;
  };

  assignedUserClick = (selectedUser) => {
    // console.log(selectedUser)
    let { task_copy } = this.state;
    let assignedUser = {
      fullName: `${selectedUser.firstName}, ${selectedUser.lastName}`,
      user: selectedUser,
    };
    task_copy = { ...task_copy, assignedUser };
    this.setState({ task_copy, users: [] });
  };

  editTask = (field, isUndo) => {
    // console.log('field---', field)
    let { updatedFields, task_copy, task, removedFields } = this.state;

    if (updatedFields.indexOf(field) == -1) {
      updatedFields.push(field);
      this.setState({ updatedFields });
    } else {
      // percentComplete
      let obj = {};

      if (isUndo) {
        let og_field = task[field];

        task_copy = { ...task_copy, [field]: og_field };
        if (field == "percentComplete") {
          // task_copy = {...task_copy, [field]: [...og_field][0] }
          // console.log('percentComplete---', task_copy)
          let pc = task[field][0];
          obj["percentComplete"] = pc;
        }
        obj.removedFields = removedFields.filter((e) => e != field);
      }
      // task_copy: {...task},
      // percentComplete: task.percentComplete &&task.percentComplete.length>0 && task.percentComplete[0].value ?task.percentComplete[0]:null,
      // selectedObjective: task.parentTask && task.parentTask.item? task.parentTask.item: {},
      // updatedFields:[]

      obj.updatedFields = updatedFields.filter((e) => e != field);
      obj.task_copy = task_copy;

      if (field == "assignedTo") {
        obj.users = [];
      }

      this.setState({ ...obj });
    }
  };

  assignedName = (user) => {
    if (user.firstName && user.lastName) {
      return user.firstName + " " + user.lastName;
    } else {
      return user.firstName;
    }
  };

  assignedUserDelay = ({ target }) => {
    let { value } = target;
    let { task_copy, removedFields, updatedFields } = this.state;
    // console.log('alp----', value)
    // task_copy = {...task_copy, assignedTo: {...task_copy.assignedTo, firstName:value, lastName:null}}

    task_copy = {
      ...task_copy,
      assignedTo: {
        // ...task_copy.assignedTo,
        firstName: value,
        lastName: null,
      },
    };

    let res = updatedFields;
    if (!value || value == undefined || value == null) {
      task_copy = { ...task_copy, assignedTo: {} };
      removedFields = [...removedFields, "assignedTo"];
      // res = updatedFields.filter(e=>e!='assignedTo')
    }

    this.setState({
      task_copy,
      // removedFields,
      updatedFields: res,
    });

    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.handleAssignUser(value);
    }, 1000);
  };

  handleChangeTaskTitle = (event) => {
    const { value } = event.target;
    let { task_copy } = this.state;
    task_copy = { ...task_copy, title: value };
    this.setState({ task_copy });
  };

  handleChangePrivacy = (val) => {
    // const { checked } = event.target;
    let { task_copy } = this.state;
    let priv = val;
    console.log("priv --- ", priv);
    task_copy = { ...task_copy, privacy: priv };
    if (val == 2) {
      this.setState({
        showLinkObjAlert: true,
        showPrivateTasksEoAlert: false,
      });
    }
    if (!isEmpty(this.state.selectedObjective) && priv === 0) {
      this.setState({
        showPublicAlert: false,
        showPrivateTasksEoAlert: true,
      });
    } else {
      this.setState({ task_copy,showPrivateTasksEoAlert: false, });
    }
  };

  assignedUserFormat = (selectedUser) => {
    // console.log(selectedUser)
    let { task_copy, removedFields } = this.state;

    task_copy = {
      ...task_copy,
      assignedTo: { ...selectedUser },
      assignedToDoc: { ...selectedUser },
    };

    this.setState({
      task_copy,
      users: [],
      removedFields: removedFields.filter((e) => e != "assignedTo"),
    });
  };

  onSubActionAdd = () => {
    const { task_copy } = this.state;
    if (this.props.handleUpdateInTable) {
      this.props.handleUpdateInTable({
        _id: task_copy._id,
        taskCounter: task_copy.taskCounter + 1,
      });
    }
    this.setState({
      task_copy: { ...task_copy, taskCounter: task_copy.taskCounter + 1 },
    });
  };

  onSubActionRemove = () => {
    const { task_copy } = this.state;
    if (this.props.handleUpdateInTable) {
      this.props.handleUpdateInTable({
        _id: task_copy._id,
        taskCounter: task_copy.taskCounter - 1,
      });
    }
    this.setState({
      task_copy: { ...task_copy, taskCounter: task_copy.taskCounter - 1 },
    });
  };

  handleAssignedChange = (changeEvent) => {
    let checkValue = changeEvent.target.checked;

    let stateUpdate = {
      isAssigned: changeEvent.target.checked,
    };

    if (!checkValue) {
      stateUpdate.users = [];
      stateUpdate.assignedUser = {};
    }

    this.setState(stateUpdate);
  };

  handleAssignUser = (value) => {
    // console.log('val---', value)
    let { removedFields } = this.state;
    let res;
    if (value && value.length > 0) {
      axios.get(url.findUser(value)).then((resp, idx) => {
        let users = resp.data.data;
        // console.log('users--', users)
        if (users.length == 0) {
          users = "No users found";
          removedFields = [...removedFields, "assignedTo"];
          res = {
            removedFields,
          };
        }

        res = {
          ...res,
          users,
        };

        this.setState({ ...res });
      });
    }
  };

  handleGoalDateChange = (date) => {
    let { task_copy, updatedFields, removedFields } = this.state;
    // console.log(date)
    if (date) {
      task_copy = { ...task_copy, dueDate: date };
      this.setState({
        task_copy,
        removedFields: removedFields.filter((e) => e != "dueDate"),
      });
    } else {
      let res = updatedFields.filter((e) => e != "dueDate");
      task_copy = { ...task_copy, dueDate: null };
      removedFields = [...removedFields, "dueDate"];
      this.setState({ task_copy, updatedFields: res, removedFields });
    }
  };

  assignedUserTimer = ({ target }) => {
    const { value } = target;
    // console.log('alp----', value)
    this.setState({ assignedUser: { fullName: value } });

    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.handleAssignUser(value);
    }, 1000);
  };

  fetchUsers = (query, callback) => {
    let users;
    // console.log(query)
    if (!query) return;
    axios
      .get(url.findUser(query))
      .then((resp, idx) =>
        resp.data.data.map((user) => ({
          display: "@" + user.firstName + " " + user.lastName,
          id: `{ "_id": "${user._id}", "email": "${
            user.email
          }", "name": "${user.firstName + " " + user.lastName}"}`,
          // {_id:user._id, email: user.email, idx},
          // name: user.firstName + " " + user.lastName,
          // _id: user._id,
          // email: user.email,
        }))
      )
      .then(callback);
  };

  createMarkup = (input) => {
    return { __html: `<div>${input}</div>` };
  };

  handleDueDateChange = (changeEvent) => {
    this.setState({
      isDueDate: changeEvent.target.checked,
      dueDate: moment(new Date()),
    });
  };

  handleChangeTaskDescription = (event) => {
    const descriptionContext = event.editor.getData();
    let { task_copy, task } = this.state;
    // console.log(task.description)
    task_copy = { ...task_copy, description: descriptionContext };
    this.setState({ task_copy: task_copy });
  };

  handleSubmitTodo = () => {
    let {
      task_copy,
      updatedFields,
      task,
      percentComplete,
      removedFields,
    } = this.state;

    if (percentComplete != null) {
      if (task_copy.percentComplete && task_copy.percentComplete.length > 0) {
        // if(  task_copy.incompleteDate!=null) {
        //   task_copy.percentComplete.unshift(percentComplete)
        // }
        task_copy.percentComplete.unshift(percentComplete);
      } else {
        task_copy.percentComplete = { ...percentComplete };
        // if(  task_copy.incompleteDate!=null) {
        //   task_copy.percentComplete = {...percentComplete}
        // }
      }
    }
    let isTitle =
      task_copy.title && task_copy.title != undefined && task_copy.title != null
        ? task_copy.title.replace(/<\/?[^>]+(>|$)/g, "")
        : "";

    let isDesc =
      task_copy.description &&
      task_copy.description != undefined &&
      task_copy.description != null
        ? task_copy.description.replace(/<\/?[^>]+(>|$)/g, "")
        : "";
    let assignedUser,
      enterpriseObj = null;

    // let isErrorCheck=[]

    // if(isTitle.length==0){
    //   isErrorCheck.push('title cannot be empty')
    // }

    // if(isDesc.length==0){
    //   isErrorCheck.push('description cannot be empty')
    // }

    // if(task_copy.dueDate){
    //   if ( moment(task_copy.dueDate).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD') ){
    //     isErrorCheck.push('due date must be greater than current date')
    //   }
    // }

    let isErrorCheck = taskValidation(task_copy);

    if (isErrorCheck.length == 0) {
      assignedUser = task_copy.assignedTo;

      if (
        task_copy.parentTask &&
        task_copy.parentTask.item &&
        task_copy.parentTask.item.title
      ) {
        enterpriseObj = task_copy.parentTask;
      }
      // let isAssigned = task_copy.assignedTo &&task_copy.assignedTo.firstName?task_copy.assignedTo.firstName.replace(/<\/?[^>]+(>|$)/g, ""):''

      if (
        task_copy.assignedTo &&
        (!task_copy.assignedTo._id ||
          task_copy.assignedTo._id == undefined ||
          task_copy.assignedTo._id == null)
      ) {
        // if(isAssigned.length==0){
        //   task_copy = {...task_copy, assignedTo:null}
        // } else {
        //   task_copy = {...task_copy, assignedTo: task.assignedTo._id}
        // }
        if (task.assignedTo && task.assignedTo._id) {
          assignedUser = task.assignedTo;
          task_copy = {
            ...task_copy,
            assignedTo: task.assignedTo._id,
            assignedToDoc: { ...task.assignedTo },
          };
        } else {
          task_copy = { ...task_copy, assignedTo: null, assignedToDoc: null };
        }
      }

      this.setState({
        errorSubmit: "",
      });

      updatedFields = [...updatedFields, ...removedFields];

      let owner = task_copy.userId;

      let payload = { taskUpdate: { ...task_copy }, updatedFields };
      axios.post(url.editTodo, payload).then(({ data }) => {
        // let newTask = {...data.data, userId:{...owner}, assignedTo:{...assignedUser}, assignedToDoc:{...assignedUser},
        // parentTask: enterpriseObj }
        let newTask = data.data;
        if (this.props.handleUpdateInTable) {
          this.props.handleUpdateInTable(newTask);
        }
        this.setState({
          task_copy: newTask,
          task: newTask,
          isDueDate: false,
          isAssigned: false,
          errorSubmit: "",
          users: [],
          updatedFields: [],
          removedFields: [],
        });
      });
    } else {
      this.setState({
        errorSubmit: `Please correct the following errors: ${isErrorCheck.join(
          ", "
        )}.`,
      });
    }
  };

  closeShareModal = () => {
    let { task } = this.state;
    this.setState({
      task_copy: { ...task },
      percentComplete:
        task.percentComplete &&
        task.percentComplete.length > 0 &&
        task.percentComplete[0].value
          ? task.percentComplete[0]
          : null,
      selectedObjective:
        task.parentTask && task.parentTask.item ? task.parentTask.item : {},
      errorSubmit: "",
      updatedFields: [],
    });
  };

  getEOList = (todo) => {
    let { updatedFields } = this.state;
    if (
      updatedFields.length == 0 ||
      (updatedFields.length > 0 && updatedFields.indexOf("EO") === -1)
    ) {
      updatedFields = [...updatedFields, "EO"];

      axios
        .get(`${url.getEnterpriseObjectives}/${todo.organizationId}`, {
          params: {
            removeDeleted: true,
          },
        })
        .then(({ data }) => {
          this.setState({
            enterpriseObjectives: [...data.data.taskList],
            enterpriseObjectivesCopy: [...data.data.taskList],
            isEObj: true,
            // updatedFields
          });
        });
    } else {
      let res = updatedFields.filter((e) => e != "EO");
      this.setState({
        updatedFields: res,
        enterpriseObjectives: [],
      });
    }
  };

  unlinkEO = (todo) => {
    let reqObject = {
      objectiveId: todo.parentTask.item,
      actionId: todo._id,
    };
    //url.unlinkEnterpriseObjectiveAction
    axios
      .post(url.unlinkEnterpriseObjectiveAction, reqObject)
      .then(({ data }) => {
        this.setState({
          objectiveId: "",
        });
      });
  };

  setNewEO = (showPrivacyUpdate = false) => {
    let { task, isAnonymous, task_copy, selectedObjective } = this.state;

    if(task.parentTask && task.parentTask.item && task.parentTask.item._id  && task_copy.privacy==1){
      showPrivacyUpdate = true
    }
    let obj = {
      objectiveId:
        selectedObjective && selectedObjective._id
          ? selectedObjective._id
          : false,
      isAnonymous,
      actionId: task._id,
    };
    console.log("object: ", obj);
    // if(task_copy && task_copy.parentTask && task_copy.parentTask.item&& selectedObjective && (selectedObjective._id == ))

    task_copy = {
      ...task_copy,
      parentTask: obj.objectiveId
        ? { item: { ...selectedObjective } }
        : { item: null },
    };

    axios.post(url.linkEnterpriseObjectiveAction, obj).then(({ data }) => {
      let newTask = data.data;
      if (this.props.handleUpdateInTable) {
        this.props.handleUpdateInTable({
          _id: newTask._id,
          parentTask: newTask.parentTask,
          parentTaskTitle: selectedObjective.title || null,
        });
      }
      this.setState({
        objectiveId: "",
        selectedObjective,
        updatedFields: showPrivacyUpdate ? ["privacy"] : [],
        task_copy,
        isEObj: false,
        task: task_copy,
      });
    });
  };

  openModalAction = (type) => {
    let text;
    switch (type) {
      case 1:
        text = "Complete";
        break;
      case 2:
        text = "Incomplete";
        break;
      case 3:
        text = "Archive";
        break;
      case 4:
        text = "Restore";
        break;
    }
    this.setState({ isActionsModal: text });
  };

  submitAction = () => {
    let { task_copy, isActionsModal } = this.state;
    if (isActionsModal === "Complete") {
      this.completeTask(task_copy);
    }
    if (isActionsModal === "Incomplete") {
      this.incompleteTask(task_copy);
    }
    if (isActionsModal === "Archive") {
      this.handleDeleteTodo(task_copy);
    }
    if (isActionsModal === "Restore") {
      this.handleUnDeleteTodo(task_copy);
    }
  };

  completeTask = (todo) => {
    let { task_copy } = this.state;
    let that = this;

    let percentComplete = {
      value: 100,
      date: moment(new Date()),
      user: this.props.user.profile._id,
    };

    if (task_copy.percentComplete && task_copy.percentComplete.length > 0) {
      task_copy.percentComplete.unshift(percentComplete);
    } else {
      task_copy.percentComplete = { ...percentComplete };
    }

    task_copy = {
      ...task_copy,
      completedDate: moment(new Date()),
      incompleteDate: null,
    };

    let payload = {
      taskUpdate: { ...task_copy },
      updatedFields: ["percentComplete", "completedDate"],
    };

    const { handleUpdateInTable } = this.props;

    axios.all([axios.put(url.markComplete(todo._id))]).then(
      axios.spread(function(completed) {
        // let complete =  completed.data.data

        task_copy = {
          ...task_copy,
          incompleteDate: null,
          completedDate: moment(new Date()),
        };

        if (handleUpdateInTable) {
          handleUpdateInTable({
            _id: task_copy._id,
            incompleteDate: null,
            completedDate: task_copy.completedDate,
            percentComplete: task_copy.percentComplete,
          });
        }

        that.setState({
          task: { ...task_copy },
          task_copy: { ...task_copy },
          task: { ...task_copy },
          isDueDate: false,
          isAssigned: false,
          percentComplete,
          users: [],
          updatedFields: [],
          isActionsModal: false,
        });
      })
    );
  };

  incompleteTask = (todo) => {
    let { task_copy } = this.state;
    let that = this;

    let percentComplete = {
      value: 0,
      date: moment(new Date()),
      user: this.props.user.profile._id,
    };

    if (task_copy.percentComplete && task_copy.percentComplete.length > 0) {
      task_copy.percentComplete.unshift(percentComplete);
    } else {
      task_copy.percentComplete = { ...percentComplete };
    }

    task_copy = {
      ...task_copy,
      incompleteDate: moment(new Date()),
      completedDate: null,
    };

    let payload = {
      taskUpdate: { ...task_copy },
      updatedFields: ["percentComplete", "incompleteDate"],
    };

    const { handleUpdateInTable } = this.props;

    axios.all([axios.put(url.markIncomplete(todo._id))]).then(
      axios.spread(function(incomplete) {
        // let complete =  completed.data.data

        task_copy = {
          ...task_copy,
          completedDate: null,
          incompleteDate: moment(new Date()),
        };
        if (handleUpdateInTable) {
          handleUpdateInTable({
            _id: task_copy._id,
            incompleteDate: task_copy.incompleteDate,
            completedDate: null,
            percentComplete: task_copy.percentComplete,
          });
        }

        that.setState({
          task: { ...task_copy },
          task_copy: { ...task_copy },
          task: { ...task_copy },
          isDueDate: false,
          isAssigned: false,
          percentComplete,
          users: [],
          updatedFields: [],
          isActionsModal: false,
        });
      })
    );
  };

  handleUnDeleteTodo = (todo) => {
    axios.put(url.undeleteTodo(todo._id)).then((data) => {
      todo = { ...todo, isDeleted: false };
      if (this.props.handleUpdateInTable) {
        this.props.handleUpdateInTable({
          _id: todo._id,
          isDeleted: false,
          operation: "UNARCHIVE",
        });
      }

      this.setState({
        isActionsModal: false,
        task: todo,
        task_copy: todo,
      });
    });
  };

  handleDeleteTodo = (todo) => {
    axios.put(url.deleteTodo(todo._id)).then((data) => {
      todo = { ...todo, isDeleted: true };
      if (this.props.handleUpdateInTable) {
        this.props.handleUpdateInTable({
          _id: todo._id,
          isDeleted: true,
          operation: "ARCHIVE",
        });
      }
      this.setState({
        isActionsModal: false,
        task: todo,
        task_copy: todo,
      });
    });
  };

  closeActionsModal = () => {
    let { task_copy } = this.state;
    this.setState({
      isActionsModal: false,
      // isResourceSelect:null,
      isUploadFiles: false,
      setImagesPreview: [],
      rejectedFiles: [],
      charts: task_copy.charts,
      tools: task_copy.tools,
      searchedTerm: "",
      isLinkItemsModal: false,
      isDueDate: false,
      isAssigned: false,
      errorSubmit: "",
      users: [],
      updatedFields: [],
      removedFields: [],
    });
  };

  getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  changeProgressInt = (event) => {
    let { task_copy } = this.state;
    let { value } = event.target;
    if (value < 101 && Number.isInteger(Number(value)) && value != null) {
      // value = Number(value)?Number(value):value
      let obj = {
        value: Number(value),
        date: new Date(),
        user: this.props.user.profile._id,
      };
      this.setState({ percentComplete: { ...obj } });
    } else {
      this.setState({ percentComplete: null });
    }
  };

  checkUserPermission = (field) => {
    let ownerFields = [
      "title",
      "archive",
      "dueDate",
      "assignedTo",
      "restore",
      "priority",
    ];
    let currentUser = this.props.user.profile;
    let { task_copy } = this.state;

    if (
      (task_copy.isDeleted && field === "restore") ||
      !task_copy.isDeleted ||
      task_copy.isDeleted != true
    ) {
      if (currentUser.orgAdmin || currentUser.role == "Admin") {
        return true;
      } else if (task_copy.isDeleted != true || field == "restore") {
        if (ownerFields.indexOf(field) > -1) {
          if (currentUser.orgAdmin) return true;
          if (currentUser.role == "Admin") return true;
          if (field === "assignedTo") {
            if (
              currentUser.orgAdmin ||
              currentUser._id === task_copy.userId._id
            ) {
              return true;
            }
          } else {
            return currentUser._id == task_copy.userId._id ? true : false;
          }
        } else {
          if (currentUser._id == task_copy.userId._id) {
            return true;
          }
          if (task_copy.assignedTo) {
            if (currentUser._id == task_copy.assignedTo._id) {
              return true;
            }
          }
        }
      }
    }
    return false;
  };

  checkProgressBarValue = () => {
    let { task_copy, percentComplete } = this.state;
    let pc = percentComplete,
      t_pc = task_copy.percentComplete,
      ic_date = task_copy.incompleteDate,
      co_date = task_copy.completedDate,
      res;

    if (pc && pc != null) {
      res = pc.value;
    } else {
      if (t_pc && t_pc.length > 0 && t_pc[0].value) {
        res = t_pc[0].value;
      } else if (ic_date && new Date(ic_date).valueOf() != NaN) {
        res = 0;
      } else if (co_date && new Date(co_date).valueOf() != NaN) {
        res = 100;
      } else if (
        ic_date &&
        co_date &&
        new Date(ic_date).valueOf() != NaN &&
        new Date(co_date).valueOf() != NaN
      ) {
        if (co_date > ic_date) {
          res = 100;
        } else {
          res = 0;
        }
      } else {
        res = 0;
      }
    }
    // console.log('res---', res)
    return res;
  };

  createdByTask = (task_copy) => {
    let currentUser = this.props.user.profile;
    let res;
    if (isUserRemoved(task_copy.userId)) {
      res = "Inactive User";
    } else if (task_copy.isAnonymous) {
      if (task_copy.userId._id.toString() != currentUser._id.toString()) {
        if (
          task_copy.assignedTo &&
          task_copy.assignedTo._id &&
          task_copy.assignedTo._id.toString() == currentUser._id.toString()
        ) {
          res = ` ${task_copy.userId.firstName} ${task_copy.userId.lastName}`;
        } else {
          res = "Anonymous";
        }
      } else {
        res = "you";
      }
    } else {
      if (task_copy.userId._id.toString() == currentUser._id.toString()) {
        res = "you";
      } else {
        res = ` ${task_copy.userId.firstName} ${task_copy.userId.lastName} `;
      }
    }

    return res;
  };

  removeTaskValue = (field) => {
    let { task_copy, removedFields, updatedFields } = this.state;
    task_copy = { ...task_copy, [field]: null };
    removedFields = [...removedFields, field];

    if (field == "assignedTo") {
      task_copy = { ...task_copy, assignedToDoc: null };
    }

    this.setState({
      task_copy,
      removedFields,
      updatedFields: updatedFields.filter((e) => e != field),
    });
  };

  dateCompare = (field1, field2, period) => {
    let d1 = moment(field1);
    let d2 = moment(field2);
    return d1.diff(d2, period);
  };

  handlePriorityChange = (task) => {
    console.log("task pri---", task);
    let { task_copy } = this.state;
    task_copy = { ...task_copy, priority: task.priority };
    this.setState({ task_copy });
    //this.editTask("priority");
  };

  isPastDueDate = (task) => {
    if (
      task.dueDate &&
      task.isDeleted != true &&
      !task.completedDate &&
      moment(task.dueDate).format("YYYY-MM-DD") < moment().format("YYYY-MM-DD")
    ) {
      return true;
    }
    return false;
  };

  renderTaskActivity = () => {
    return <TaskActivity task={this.state.task_copy} />;
  };

  setPrivacyToPrivateAndRemoveEOIfLinked = () => {
    const { task_copy, selectedObjective } = this.state;

    if (task_copy.privacy == 2 || task_copy.privacy == 1) {
      this.setState(
        {
          selectedObjective: {},
          task_copy: {
            ...task_copy,
            privacy: 1,
          },
        },
        () => {
          this.setNewEO(true);
          this.setState({
            showPrivateTasksEoAlert: false,
          });
        }
      );
    }
  };

  renderTask = () => {
    let {
      showPublicAlert,
      showPrivateTasksEoAlert,
      task,
      task_copy,
      updatedFields,
      percentComplete,
      isArchived,
      users,
      enterpriseObjectives,
      removedFields,
      optionsDropdownOpen,
      isEObj,
      selectedObjective,
      isAnonymous,
      enterpriseObjectivesCopy,
    } = this.state;
    let { dueDate, type } = task_copy;

    let currentUser = this.props.user.profile;
    if (task_copy && task_copy.userId) {
      let task_img = task_copy.profilePic ? task_copy.profilePic : UserIcon1;
      let taskAssignedUser =
        task_copy.assignedTo && task_copy.assignedTo._id
          ? task_copy.assignedTo
          : task.assignedTo;

      console.log("task_copy.privacy --- ", task_copy.privacy);
      const {orgAdmin} = this.props.user.profile;
      return (
        // card
        <div className=" singleTaskCard">
          <div className="card-body d-flex">
            <span className="single-task-left-side">
              {task_copy.type === "subAction" && (
                <div className="singleTaskGoBackContainter">
                  <span
                    className="cursor-pointer"
                    onClick={() =>
                      this.goBackParentHandler(task_copy.parentTask.item)
                    }
                  >
                    {task_copy.parentTask && task_copy.parentTask.item && (
                      <span className="">
                        {" "}
                        <BiArrowBack />{" "}
                        {`Back to ${task_copy.parentTask.item.title}`}{" "}
                      </span>
                    )}
                  </span>
                </div>
              )}

              <span className="singleTaskTitleContainer mt-3">
                {updatedFields.indexOf("title") > -1 ? (
                  <Input
                    type="text"
                    onChange={this.handleChangeTaskTitle}
                    value={task_copy.title}
                    autoComplete={"off"}
                    className="singleTaskTitleEdit"
                    maxLength={64}
                  />
                ) : (
                  <h5
                    className={
                      this.checkUserPermission("title")
                        ? "card-title editableTaskField"
                        : "card-title"
                    }
                    onClick={
                      this.checkUserPermission("title")
                        ? () => this.editTask("title")
                        : null
                    }
                  >
                    {task_copy.title ? task_copy.title : "Add Title"}
                  </h5>
                )}
                {this.checkUserPermission("title") ? (
                  updatedFields.indexOf("title") > -1 ? (
                    <span
                      className="singleTaskEditBtn"
                      onClick={() => this.editTask("title")}
                    >
                      Close
                    </span>
                  ) : (
                    <span
                      className="singleTaskEditBtn"
                      onClick={() => this.editTask("title")}
                    >
                      Edit
                    </span>
                  )
                ) : null}
              </span>

              <span className="singleTaskBasicInfo">
                {task_copy.isDeleted === true ? (
                  <span className="singleTaskOwner single-task-archived-content">
                    <span className="single-task-archived-txt">
                      Archived on{" "}
                    </span>
                    <span className="singleTaskDate">
                      {moment
                        .parseZone(task_copy.isDeletedDate)
                        .format("MM/DD/YYYY")}
                      .{" "}
                    </span>
                    {this.checkUserPermission("restore") ? (
                      // <span  className="single-task-archived-txt-restore-option"  onClick={() => this.openModalAction(4)} >
                      <span
                        className="single-task-archived-txt-restore-option"
                        onClick={() => this.handleUnDeleteTodo(task_copy)}
                      >
                        <span className="">Click here to Restore Action</span>
                        <span
                          style={{
                            color: "#5099DE",
                            fontSize: "0.8rem",
                            // float: "right",
                          }}
                          className="flaticon-update"
                        ></span>
                      </span>
                    ) : null}
                  </span>
                ) : // <span className="archivedTask">
                //   <span className="archived-tag">Archived</span>
                // </span>
                null}
                {/* {!task_copy.dueDate &&
              !task_copy.isDeleted &&
              !task.completedDate ? (
                <div className="task_ongoing_txt">Ongoing</div>
              ) : null} */}
                <div>
                  <span className="singleTaskOwner">
                    {this.props.linkedByText}
                  </span>
                </div>
                <span className="singleTaskOwner">
                  created by {this.createdByTask(task_copy)}
                </span>{" "}
                {["Anonymous", "you"].includes(
                  this.createdByTask(task_copy)
                ) ? (
                  ""
                ) : (
                  <span className="user_gender_pronoun_planning">
                    {renderGenderPronoun(task_copy.userId)}{" "}
                  </span>
                )}
                on{" "}
                <span className="singleTaskDate">
                  {moment.parseZone(task_copy.createdOn).format("MM/DD/YYYY")}

                  {task_copy.lastUpdate ? (
                    <span className="">
                      {" "}
                      * updated on{" "}
                      {moment
                        .parseZone(task_copy.lastUpdate)
                        .format("MM/DD/YYYY")}
                    </span>
                  ) : null}
                </span>
                {task_copy.completedDate ? (
                  <div>
                    <span className="">
                      {" "}
                      Completed on
                      {/* <i className="flaticon-calendar ml5"></i>  */}
                      <span className="">
                        {" "}
                        {moment(task_copy.completedDate).format(
                          "MMM D, YYYY"
                        )}{" "}
                      </span>
                    </span>
                  </div>
                ) : null}
                {task_copy.completedDate == null || !task_copy.completedDate ? (
                  <div
                    className={
                      this.checkUserPermission("dueDate")
                        ? `editableTaskField singleTaskDueDateContainer ${
                            this.isPastDueDate(task_copy)
                              ? "dueDatePastTxt"
                              : ""
                          }`
                        : `singleTaskDueDateContainer ${
                            this.isPastDueDate(task_copy)
                              ? "dueDatePastTxt"
                              : ""
                          }`
                    }
                  >
                    <span
                      onClick={
                        this.checkUserPermission("dueDate")
                          ? () => this.editTask("dueDate")
                          : null
                      }
                    >
                      {task_copy.isDeleted ? (
                        task_copy.dueDate ? (
                          <span>
                            <i className="flaticon-calendar"></i> due on{" "}
                            {moment(task_copy.dueDate).format("MM/DD/YYYY")}
                          </span>
                        ) : null
                      ) : task_copy.dueDate ? (
                        <span>
                          <i className="flaticon-calendar"></i> due on{" "}
                          {moment(task_copy.dueDate).format("MM/DD/YYYY")}
                        </span>
                      ) : (
                        <span>
                          This task is{" "}
                          <span className="task_ongoing_txt">on-going</span>.{" "}
                          <span className="card-link">
                            Click here to add a due date
                          </span>
                        </span>
                      )}

                      {this.isPastDueDate(task_copy) ? (
                        <span className="dueDatePastTxt">&nbsp;(PAST DUE)</span>
                      ) : null}
                    </span>

                    {this.checkUserPermission("dueDate") &&
                    !task_copy.isDeleted ? (
                      updatedFields.indexOf("dueDate") > -1 ? (
                        <span>
                          <span
                            onClick={() => this.editTask("dueDate")}
                            className="singleTaskEditBtn"
                          >
                            Close
                          </span>

                          {dueDate ? (
                            <span
                              className="flaticon-trash singleTaskEditBtn"
                              onClick={
                                this.checkUserPermission("dueDate")
                                  ? () => this.removeTaskValue("dueDate")
                                  : null
                              }
                            >
                              Clear
                            </span>
                          ) : null}
                        </span>
                      ) : (
                        <span
                          onClick={() => this.editTask("dueDate")}
                          className="singleTaskEditBtn"
                        >
                          Edit
                        </span>
                      )
                    ) : null}

                    {!task_copy.isDeleted && task_copy.dueDate ? (
                      <span className="dueDateTask_addCal">
                        {/* Click here to add this task to your calendar */}
                        <CalendarAdd
                          description={task_copy.description}
                          item={task_copy}
                        />
                      </span>
                    ) : null}

                    {this.checkUserPermission("dueDate") ? (
                      updatedFields.indexOf("dueDate") > -1 ? (
                        <span className="singleTaskDueDate">
                          <DatePicker
                            id="actionDueDate"
                            placeholderText="Enter date: MM/DD/YYYY"
                            className="set-goal input-custom-date form-control"
                            selected={
                              dueDate ? moment(task_copy.dueDate) : null
                            }
                            onChange={this.handleGoalDateChange}
                            minDate={moment(new Date())}
                            isClearable={false}
                            showYearDropdown
                          />
                        </span>
                      ) : null
                    ) : null}
                  </div>
                ) : task_copy.dueDate ? (
                  <div>
                    {this.dateCompare(
                      task_copy.completedDate,
                      task_copy.dueDate,
                      "days"
                    ) > 0 ? (
                      <span className="">
                        {" "}
                        Due date was{" "}
                        {moment(task_copy.dueDate).format("MMM D, YYYY")}.
                        Action was completed
                        {` ${this.dateCompare(
                          task_copy.completedDate,
                          task_copy.dueDate,
                          "days"
                        )}`}{" "}
                        day(s) after the due date.
                      </span>
                    ) : (
                      <span className="">
                        {" "}
                        Due date was{" "}
                        {moment(task_copy.dueDate).format("MMM D, YYYY")}.
                      </span>
                    )}
                    {/* <span className=''> {moment(task_copy.dueDate).format("MMM D, YYYY")} </span> */}
                  </div>
                ) : null}
                {task_copy.isDelete && task_copy.deletedDate ? (
                  <span className="">
                    {" "}
                    Archived on
                    <span className="">
                      &nbsp;
                      {moment(task_copy.deletedDate).format("MMM D, YYYY")}{" "}
                    </span>
                  </span>
                ) : null}
                <span>
                  {updatedFields.indexOf("priority") > -1 ? (
                    <PriorityContainer
                      isActive={true}
                      size={"19px"}
                      forceOpen={true}
                      canEdit={this.checkUserPermission("priority")}
                      index={-1}
                      concatVal={"Priority"}
                      task={{ priority: task_copy.priority }}
                      handlePriorityChange={this.handlePriorityChange}
                    />
                  ) : (
                    <PriorityContainer
                      isActive={true}
                      size={"19px"}
                      canEdit={false}
                      index={-1}
                      concatVal={"Priority"}
                      task={{ priority: task_copy.priority }}
                      handlePriorityChange={this.handlePriorityChange}
                    />
                  )}

                  {this.checkUserPermission("priority") ? (
                    updatedFields.indexOf("priority") > -1 ? (
                      <span
                        className="singleTaskEditBtn"
                        onClick={() => this.editTask("priority")}
                      >
                        Close
                      </span>
                    ) : (
                      <span
                        className="singleTaskEditBtn"
                        onClick={() => this.editTask("priority")}
                      >
                        Edit
                      </span>
                    )
                  ) : null}
                </span>
              </span>

              <span className="privacy-edit-align d-flex align-items-center">
                <span
                  className="cursor-pointer"
                  style={{ marginRight: "0.7em" }}
                >
                  <BiLock
                    size={"22px"}
                    className="mb-1"
                    color={"rgb(119 119 119 / 82%)"}
                  />{" "}
                </span>
                <span className="singleTaskDesTxt">Privacy</span>{" "}
                <span className="ml-1">is</span>
                {updatedFields.indexOf("privacy") > -1 ? (
                  <span className="ml-1">
                    {/* <Toggle
                      checked={
                        (task_copy.privacy == 1 && task_copy.privacy != 0) ||
                        (task_copy.privacy == null && task_copy.privacy != 0)
                      }
                      icon={false}
                      onChange={this.handleChangePrivacy}
                    />
                    <span className="ml-1">
                      {
                        privacyMap[
                          task_copy.privacy == null || task_copy.privacy == 1
                            ? 1
                            : 0
                        ]
                      }
                    </span> */}
                    <div
                      style={{
                        width: "200px",
                        marginLeft: "4px",
                      }}
                    >
                      <Select
                        value={task_copy.privacy}
                        label="Select Privacy"
                        onChange={(e) => {
                          if (e) {
                            this.handleChangePrivacy(e.value);
                          } else {
                            this.handleChangePrivacy(null);
                          }
                        }}
                        placeholder="Select privacy"
                        options={privacy_options}
                      />
                    </div>
                  </span>
                ) : (
                  <span className="ml-1">
                    {" "}
                    {
                      privacyMap[
                        task_copy.privacy == null || task_copy.privacy == 1
                          ? 1
                          : task_copy.privacy == 0
                          ? 0
                          : 2
                      ]
                    }
                  </span>
                )}
                {this.checkUserPermission("privacy") ? (
                  updatedFields.indexOf("privacy") > -1 ? (
                    <span
                      className="singleTaskEditBtn"
                      onClick={() => this.editTask("privacy")}
                    >
                      Close
                    </span>
                  ) : (
                    <span
                      className="singleTaskEditBtn"
                      onClick={() => this.editTask("privacy")}
                    >
                      Edit
                    </span>
                  )
                ) : null}
              </span>

              {type !== "subAction" && this.state.showLinkObjAlert ? (
                <span>
                  <Alert color={"info"} className="mt-2">
                    Please link enterprise objective from bottom.
                  </Alert>
                </span>
              ) : (
                ""
              )}

              {showPublicAlert && (
                <span>
                  <Alert color={"info"} className="mt-2">
                    By adding an objective your action will be made 
                    linked
                  </Alert>
                </span>
              )}
              {showPrivateTasksEoAlert && (
                <span>
                  <Alert color="info">
                    <div>
                      Changing the privacy to Private will unlink this action
                      from the Objective. Do you want to proceed?
                      <Button
                        onClick={() =>
                          this.setPrivacyToPrivateAndRemoveEOIfLinked()
                        }
                        color="success"
                        size="sm"
                      >
                        Yes
                      </Button>
                      <Button
                        className="ml-2"
                        onClick={() => {
                          this.setState({
                            showPrivateTasksEoAlert: false,
                          });
                        }}
                        color="danger"
                        size="sm"
                      >
                        No
                      </Button>
                    </div>
                    {/* <div>
                        <Button
                          onClick={() =>
                            this.setPrivacyToPrivateAndRemoveEOIfLinked()
                          }
                          color="success"
                          size="sm"
                        >
                          Yes
                        </Button>
                        <Button
                          className="ml-2"
                          onClick={() => {
                            this.setState({
                              showPrivateTasksEoAlert: false,
                            });
                          }}
                          color="danger"
                          size="sm"
                        >
                          No
                        </Button>
                      </div> */}
                  </Alert>
                </span>
              )}

              <span className="singleTaskProgressContainer">
                <span className="singleTaskProgressTxt">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="30"
                    fill="currentColor"
                    className={
                      this.checkUserPermission("percentComplete") &&
                      task_copy.completedDate == null
                        ? "bi-card-checklist singleTaskIconClass editableTaskField"
                        : "bi bi-card-checklist singleTaskIconClass"
                    }
                    viewBox="0 0 16 16"
                    onClick={
                      this.checkUserPermission("percentComplete") &&
                      task_copy.completedDate == null
                        ? () => this.editTask("percentComplete")
                        : null
                    }
                  >
                    <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z" />
                    <path d="M7 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0zM7 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0z" />
                  </svg>
                  Progress{" "}
                  {this.checkUserPermission("percentComplete") &&
                  task_copy.completedDate == null ? (
                    updatedFields.indexOf("percentComplete") > -1 ? (
                      <span className="singleTaskProgressInput">
                        <Input
                          min={0}
                          max={100}
                          type="number"
                          step="1"
                          className="inputBox-height singleTaskProgressInteger"
                          onChange={this.changeProgressInt}
                          value={
                            percentComplete &&
                            Object.keys(percentComplete).length > 0
                              ? percentComplete.value
                              : 0
                          }
                        />
                      </span>
                    ) : null
                  ) : null}
                  {this.checkUserPermission("percentComplete") &&
                  task_copy.completedDate == null ? (
                    updatedFields.indexOf("percentComplete") > -1 ? (
                      <span
                        className="singleTaskEditBtn"
                        onClick={
                          this.checkUserPermission("percentComplete")
                            ? () => this.editTask("percentComplete")
                            : null
                        }
                      >
                        Close
                      </span>
                    ) : (
                      <span
                        className="singleTaskEditBtn"
                        onClick={
                          this.checkUserPermission("percentComplete")
                            ? () => this.editTask("percentComplete")
                            : null
                        }
                      >
                        Edit
                      </span>
                    )
                  ) : null}
                </span>
                <div className="singleTaskProgressBar">
                  {this.checkProgressBarValue(task_copy) == 0 ? (
                    <span className="zeroPercentProgress">0%</span>
                  ) : null}
                  <Progress
                    className={
                      this.checkUserPermission("percentComplete") &&
                      task_copy.completedDate == null
                        ? `singleTaskProgress editableTaskField ${
                            this.checkProgressBarValue(task_copy) == 100
                              ? "progressCompleted"
                              : ""
                          }`
                        : `singleTaskProgress ${
                            this.checkProgressBarValue(task_copy) == 100
                              ? "progressCompleted"
                              : ""
                          }`
                    }
                    // value="25"
                    // animated
                    // multi
                    label={this.checkProgressBarValue(task_copy)}
                    color="success"
                    striped={
                      this.checkProgressBarValue(task_copy) == 100
                        ? false
                        : true
                    }
                    onClick={
                      this.checkUserPermission("percentComplete") &&
                      task_copy.completedDate == null
                        ? () => this.editTask("percentComplete")
                        : null
                    }
                    value={this.checkProgressBarValue(task_copy)}
                  >
                    {this.checkProgressBarValue(task_copy)}%
                  </Progress>

                  {/* {this.checkUserPermission("percentComplete") &&
                task_copy.completedDate == null ? (
                  updatedFields.indexOf("percentComplete") > -1 ? (
                    <span className="singleTaskProgressInput">
                      <Input
                        min={0}
                        max={100}
                        type="number"
                        step="1"
                        className="inputBox-height singleTaskProgressInteger"
                        onChange={this.changeProgressInt}
                        value={
                          percentComplete &&
                          Object.keys(percentComplete).length > 0
                            ? percentComplete.value
                            : 0
                        }
                      />
                    </span>
                  ) : null
                ) : null} */}
                </div>
              </span>

              <div className="singleTaskDesContainer">
                <div
                  className={
                    this.checkUserPermission("description")
                      ? "editableTaskField"
                      : ""
                  }
                >
                  <i
                    className={"flaticon-edit singleTaskIconClass"}
                    style={{ color: "#777777" }}
                  ></i>
                  <span className="singleTaskDesTxt">
                    Description{" "}
                    {this.checkUserPermission("description") ? (
                      updatedFields.indexOf("description") > -1 ? (
                        <span
                          className="singleTaskEditBtn"
                          onClick={
                            this.checkUserPermission("description")
                              ? () => this.editTask("description")
                              : null
                          }
                        >
                          Close
                        </span>
                      ) : (
                        <span
                          className="singleTaskEditBtn"
                          onClick={
                            this.checkUserPermission("description")
                              ? () => this.editTask("description")
                              : null
                          }
                        >
                          Edit
                        </span>
                      )
                    ) : null}
                  </span>
                </div>
                {updatedFields.indexOf("description") > -1 ? (
                  <span>
                    <p
                      className={
                        this.checkUserPermission("description")
                          ? "card-text editableTaskField"
                          : "card-text "
                      }
                      onClick={
                        this.checkUserPermission("description")
                          ? () => this.editTask("description")
                          : null
                      }
                    />
                    <CKEditorUI
                      onChange={this.handleChangeTaskDescription}
                      value={task_copy.description}
                      afterPaste={this.addText}
                    />
                  </span>
                ) : (
                  <p
                    className={
                      this.checkUserPermission("description")
                        ? "card-text editableTaskField"
                        : "card-text "
                    }
                    // onClick={
                    //   this.checkUserPermission("description")
                    //     ? () => this.editTask("description")
                    //     : null
                    // }
                    dangerouslySetInnerHTML={this.createMarkup(
                      task_copy.description
                    )}
                  />
                )}
              </div>

              {task_copy && task_copy._id ? (
                <div className="assignee-div-editTask">
                  {taskAssignedUser && (
                    <span className="cursor-pointer assign-border-wrapper">
                      {" "}
                      <BiUserPlus size={"24px"} />{" "}
                    </span>
                  )}

                  {taskAssignedUser && (
                    <span className="singleTaskDesTxt ml-1">Assigned to</span>
                  )}
                  <AssigneeDropdown
                    currentUser={currentUser}
                    taskAssignedUser={taskAssignedUser}
                    editTask={this.editTask}
                    assignedUserFormat={this.assignedUserFormat}
                    task={task_copy}
                    removeUser={() => this.removeTaskValue("assignedTo")}
                    noMargin
                    noEditable={task_copy.type == "subAction"? false  :  !this.checkUserPermission("assignedTo")}
                    textContainerStyle={{
                      marginLeft: taskAssignedUser ? "20px" : "5px",
                    }}
                    forcetextPadding
                    helpText={taskAssignedUser ? "" : "Assign to user"}
                  />
                </div>
              ) : (
                ""
              )}

              {type !== "subAction" && (
                <div>
                  {isEObj ? (
                    <div>
                      <div className="singleTaskModalBody">
                        <span className="singleTaskModalBodyTxt">
                          Select the Enterprise DEI Objective to link your
                          Action with.
                          <div
                            className="singleActionAnonymous"
                            hidden={!this.state.isAnonymousVisible}
                          >
                            <span className="">
                              <Toggle
                                checked={isAnonymous}
                                icons={false}
                                onChange={this.handlePermissionChange}
                              />
                            </span>
                            <span className="permission-value ml10">
                              Anonymous
                            </span>
                          </div>
                          {task_copy.parentTask && task_copy.parentTask.item ? (
                            <span>
                              It is currently attached on{" "}
                              <strong>
                                {task_copy.parentTask.item.title} objective.
                              </strong>{" "}
                            </span>
                          ) : null}
                        </span>

                        {enterpriseObjectivesCopy.length > 0 && (
                          <Input
                            className="search-eo-input"
                            placeholder="Type objective title ...."
                            onChange={(e) => {
                              const value = e.target.value;

                              let objectives = [
                                ...this.state.enterpriseObjectivesCopy,
                              ];

                              if (value) {
                                objectives = objectives.filter((eo) =>
                                  eo.title
                                    .toLowerCase()
                                    .includes(value.toLowerCase())
                                );
                                this.setState({
                                  enterpriseObjectives: [...objectives],
                                });
                              } else {
                                objectives = [
                                  ...this.state.enterpriseObjectivesCopy,
                                ];
                                this.setState({
                                  enterpriseObjectives: [...objectives],
                                });
                              }
                            }}
                          />
                        )}

                        {enterpriseObjectives &&
                        enterpriseObjectives.length > 0 ? (
                          <div className="divTableSingleTask">
                            <div className="divTableBody">
                              {enterpriseObjectives.map((eo, idx) => {
                                return (
                                  <span key={eo._id + idx}>
                                    <Checkbox
                                      className="singleTaskLinkCheckBox"
                                      checked={
                                        selectedObjective &&
                                        selectedObjective._id === eo._id
                                      }
                                      type="checkbox"
                                      onClick={() => this.addEntObj(eo)}
                                    />

                                    {eo.title}
                                  </span>
                                );
                              })}
                            </div>
                          </div>
                        ) : null}
                      </div>

                      <div
                        className="singleTaskModalBtn"
                        style={{ padding: "10px 0px 0px 0px" }}
                      >
                        <Button
                          className="profile-modal-save-btn weeklyWinBtn"
                          onClick={() => this.setNewEO()}
                          // disabled={!this.state.isEnterpriseObjectiveSelected}
                        >
                          <span className="profile-modal-save-btn-txt">
                            (Un)Attach
                            <span className="ml10 flaticon-tick"></span>
                          </span>
                        </Button>

                        <Button
                          className="profile-modal-cancel-btn float-right weeklyWinBtn"
                          onClick={() => this.closeEObjModal()}
                        >
                          <span className="profile-modal-cancel-btn-txt">
                            Cancel
                          </span>
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <div>
                      {task_copy.parentTask &&
                      task_copy.parentTask.item &&
                      task_copy.parentTask.item.title ? (
                        <div className="singleTaskEOContainter">
                          <span className="flaticon-clip singleTaskIconClass"></span>
                          <span
                            className={`singleTaskEO ${task_copy.parentTask.item.isDeleted && !orgAdmin ? "archived-objective" :""}`}
                            onClick={() =>{
                              if(task_copy.parentTask.item.isDeleted){

                                if(orgAdmin){
                                  this.navigateToEO(task_copy.parentTask.item._id)
                                }

                              }else{
                                this.navigateToEO(task_copy.parentTask.item._id)
                              }
                            }
                             
                            }
                          >
                            Part of{" "}
                            <span
                              className="tooltip-text"
                              data-tip={task_copy.parentTask.item.title}
                            >
                              <span className="entObjTitle">
                                {task_copy.parentTask.item.title}
                              </span>{" "}
                              enterprise objective{" "}
                              {
                                task_copy.parentTask.item.isDeleted ? "(Archived)" :""
                              }
                            </span>
                          </span>
                          <ReactTooltip />
                          {task_copy.parentTask.item.isDeleted != true ? (
                            <a
                              className="card-link singleTaskEditBtn"
                              onClick={() =>
                                this.navigateToEO(task_copy.parentTask.item._id)
                              }
                            >
                              {" "}
                              View
                            </a>
                          ) : null}

                          {task_copy.isDeleted != true &&
                          this.checkUserPermission("entObj") ? (
                            updatedFields.indexOf("entObj") > -1 ? (
                              <span
                                className="singleTaskEditBtn"
                                onClick={() => this.getEOList(task_copy)}
                              >
                                Close
                              </span>
                            ) : (
                              <span
                                className="singleTaskEditBtn"
                                onClick={() => this.getEOList(task_copy)}
                              >
                                Edit
                              </span>
                            )
                          ) : null}
                        </div>
                      ) : (
                        <div className="singleTaskEOContainter">
                          <span className="flaticon-clip singleTaskIconClass"></span>
                          {task_copy.isDeleted != true ? (
                            <span
                              className={
                                task_copy.isDeleted != true
                                  ? "singleTaskEO card-link"
                                  : ""
                              }
                              onClick={
                                this.checkUserPermission("entObj")
                                  ? () => this.getEOList(task_copy)
                                  : null
                              }
                            >
                              {" "}
                              Link to Objective{" "}
                            </span>
                          ) : (
                            <span
                              className={
                                task_copy.isDeleted != true
                                  ? "singleTaskEO card-link"
                                  : ""
                              }
                            >
                              {" "}
                              No Objective linked to this action{" "}
                            </span>
                          )}
                          {task_copy.isDeleted != true &&
                          this.checkUserPermission("entObj") ? (
                            updatedFields.indexOf("entObj") > -1 ? (
                              <span
                                className="singleTaskEditBtn"
                                onClick={
                                  this.checkUserPermission("entObj")
                                    ? () => this.getEOList(task_copy)
                                    : null
                                }
                              >
                                Close
                              </span>
                            ) : (
                              <span
                                className="singleTaskEditBtn"
                                onClick={
                                  this.checkUserPermission("entObj")
                                    ? () => this.getEOList(task_copy)
                                    : null
                                }
                              >
                                Edit
                              </span>
                            )
                          ) : null}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </span>

            <div
              className="d-flex manage-line-titlep"
              style={{
                position: "absolute",
                right: "4px",
              }}
            >
              <span className="cursor-pointer pb-2">
                <ShareEntity
                  col
                  item={{
                    _id: task_copy._id,
                    description: task_copy.description,
                    assigneeName: this.getAssigneeName(task_copy),
                    dueDate: task_copy.dueDate
                      ? moment(task_copy.dueDate).format("MMM D, YYYY")
                      : "On-Going",
                    title: task_copy.title,
                    progress:
                      this.checkProgressBarValue(task_copy) == 0
                        ? "Not Started"
                        : inRange(
                            this.checkProgressBarValue(task_copy),
                            0,
                            99.99
                          )
                        ? `${this.checkProgressBarValue(task_copy)}%`
                        : "Completed",
                    status: this.isDueDatePast(task_copy)
                      ? "Overdue"
                      : !task_copy.isDeleted
                      ? "Active"
                      : "Archived",
                    objectiveName:
                      (task_copy.parentTask &&
                        task_copy.parentTask.item &&
                        task_copy.parentTask.item.title) ||
                      "No objective",
                    priority: task_priority(task_copy.priority),
                    privacy: privacyMap[task_copy.privacy],
                    createdByName: task_copy.userId
                      ? task_copy.userId.firstName +
                        " " +
                        task_copy.userId.lastName
                      : "No name",
                    createdOn: moment(task_copy.createdOn).format(
                      "MMM D, YYYY"
                    ),
                  }}
                  user={this.props.user}
                  entityType="ACTION"
                  display="POPPER"
                />
              </span>
              {!isMobile && (
                <div className="cursor-pointer">
                  <Dropdown
                    isOpen={optionsDropdownOpen}
                    toggle={() =>
                      this.setState({
                        optionsDropdownOpen: !optionsDropdownOpen,
                      })
                    }
                    direction="left"
                  >
                    <DropdownToggle tag="span">
                      <BiDotsVertical size="26px" />
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem>
                        {this.checkUserPermission("isComplete") ? (
                          task_copy.completedDate == undefined ? (
                            <span
                              className="singleTaskCompleteContainer editableTaskField"
                              onClick={() => this.openModalAction(1)}
                            >
                              <span className="singleTaskCompleteTxt">
                                Mark Complete
                              </span>

                              <BiCheck color="green" size="24px" />
                              {/* <Checkbox checked={false} type="checkbox" /> */}
                            </span>
                          ) : (
                            <span
                              className="singleTaskCompleteContainer editableTaskField"
                              onClick={() => this.openModalAction(2)}
                            >
                              <span className="singleTaskCompleteTxt">
                                Mark Incomplete
                              </span>

                              <BiX color="red" size="24px" />
                              {/* <Checkbox checked={true} type="checkbox" /> */}
                            </span>
                          )
                        ) : (
                          <span className="singleTaskCompleteContainer">
                            <span className="singleTaskCompleteTxt">
                              {task_copy.completedDate == undefined
                                ? "Incomplete"
                                : "Completed"}
                            </span>
                          </span>
                        )}
                      </DropdownItem>
                      <DropdownItem divider />
                      <DropdownItem>
                        {task_copy.isDeleted != true ? (
                          this.checkUserPermission("archive") ? (
                            <div
                              className=""
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                              onClick={() => this.openModalAction(3)}
                            >
                              <span className="">Archive</span>
                              <span
                                style={{
                                  color: "#5099DE",
                                  fontSize: "0.8rem",
                                  float: "right",
                                }}
                                className="flaticon-trash"
                              ></span>
                            </div>
                          ) : null
                        ) : this.checkUserPermission("restore") ? (
                          <div
                            className=""
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            onClick={() => this.openModalAction(4)}
                          >
                            <span className="">Restore Action</span>
                            <span
                              style={{
                                color: "#5099DE",
                                fontSize: "0.8rem",
                                float: "right",
                              }}
                              className="flaticon-update"
                            ></span>
                          </div>
                        ) : null}
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>
              )}
            </div>

            {/* <span className="single-task-right-side">

          <TaskActivity task = {task_copy} />

            {
              this.renderTaskActivity()
            }             


        </span> */}

            {/* <a className="card-link" onClick={()=>this.isEditModal()}> Edit action </a> */}
          </div>
        </div>
      );
    }
  };

  getAssigneeName = (task) => {
    if (
      task &&
      task.assignedTo &&
      (task.assignedTo.firstName || task.assignedTo._id)
    ) {
      let assignedUser =
        task.assignedTo && task.assignedTo.firstName
          ? task.assignedTo
          : task.assignedToDoc
          ? task.assignedToDoc
          : false;

      let assignedUserFullName = assignedUser.lastName
        ? assignedUser.firstName + " " + assignedUser.lastName
        : assignedUser.firstName
        ? assignedUser.firstName
        : "";
      let { profile } = this.props.user;
      let taskOwner = isUserRemoved(task.userId)
        ? "Inactive User"
        : task.userId._id.toString() == profile._id.toString()
        ? profile
        : task.userId;

      assignedUserFullName = isUserRemoved(task.assignedTo)
        ? "Inactive User"
        : assignedUserFullName;

      return assignedUserFullName;
    } else {
      return "None";
    }
  };

  addEntObj = (eo) => {
    let { selectedObjective, task_copy } = this.state;
    if (selectedObjective._id != eo._id) {
      this.setState({
        selectedObjective: { ...eo },
        task_copy: {
          ...this.state.task_copy,
          privacy: 2,
        },
        showPublicAlert: true,
        showLinkObjAlert: false,
      });
    } else {
      console.log(task_copy.privacy)
      this.setState({
        selectedObjective: {},
        isAnonymous: false,
        showPublicAlert: false,
        task_copy: {
          ...this.state.task_copy,
          privacy:task_copy.privacy==2 ? 1: task_copy.privacy
        },
        
      });
    }
  };

  closeEObjModal = () => {
    this.setState((prevState) => ({
      selectedObjective:
        prevState.task.parentTask && prevState.task.parentTask.item
          ? prevState.task.parentTask.item
          : {},
      isEObj: false,
    }));
  };

  handlePermissionChange = (changeEvent) => {
    this.setState({
      isAnonymous: changeEvent.target.checked,
    });
  };

  toggleTaskView = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  };

  getItems = (item) => {
    let { task_copy } = this.state;
    if (item == "C") {
      let payload = {
        category: "All",
        pageNumber: 0,
        count: "all",
        linkedCharts:
          task_copy.charts && task_copy.charts.length > 0
            ? task_copy.charts.map((e) => e.itemId)
            : [],
      };

      axios.post(url.fetchCharts, payload).then(({ data }) => {
        let result = data.data;
        this.setState({
          allItems: result,
          linkedItems: result,
          linkedItemsCount: result.length,
          isResourceSelect: 1,
          isLinkItemsModal: true,
        });
      });
    }

    if (item == "T") {
      let payload = {
        category: "All",
        pageNumber: 0,
        count: "all",
        linkedTools:
          task_copy.tools && task_copy.tools.length > 0
            ? task_copy.tools.map((e) => e.itemId)
            : [],
      };
      axios
        .post(url.fetchTools, payload)
        .then(({ data }) => {
          let result = data.data;
          this.setState({
            allItems: result,
            linkedItems: result,
            linkedItemsCount: result.length,
            isResourceSelect: 2,
            isLinkItemsModal: true,
          });
        })
        .catch((error) => {
          //todo show error
        });
    }

    if (item == "U") {
      this.setState({ isUploadFiles: true });
    }

    if (item == "G") {
      this.setState({
        isResourceSelect: 3,
        isGroupModal: true,
      });
    }
  };

  isItemLinked = (itm, type) => {
    if (type == 1) {
      // charts
      let { charts } = this.state;
      return (
        findIndex(charts, (ch) => {
          return itm._id === ch.itemId.toString();
        }) > -1
      );
    }
    if (type == 2) {
      let { tools } = this.state;
      return (
        findIndex(tools, (tool) => {
          return itm._id === tool.itemId.toString();
        }) > -1
      );
      // tools.indexOf(itm._id)>-1
      // findIndex(charts,(ch) => {return itm._id === ch._id}) > -1
    }
  };

  editLinkedItem = (item, type) => {
    let { allItems, searchedTerm, charts, tools } = this.state;
    if (type == 1) {
      if (
        (charts.length > 0 &&
          findIndex(charts, (c) => {
            return item._id.toString() === c.itemId.toString();
          }) === -1) ||
        charts.length == 0
      ) {
        let obj = {
          itemId: item._id,
          date: new Date(),
          user: this.props.user.profile._id,
          firstName: this.props.user.profile.firstName,
          lastName: this.props.user.profile.lastName,
          type: "Chart",
          category: item.category,
          organizationId: this.props.user.profile.organizationId._id,
          chartData: { ...item },
        };

        let index = allItems.findIndex((el) => el._id == item._id);

        // let res = charts.concat(obj)
        let res = [obj, ...charts];
        item = { ...item, selected: true, type: obj.type };
        allItems[index] = item;

        let stateObj = { charts: res, allItems };

        if (searchedTerm.length === 0) {
          stateObj = { ...stateObj, linkedItems: allItems };
        }

        this.setState(stateObj);
      } else {
        let mod_chart = filter(
          charts,
          (c) => c.itemId.toString() != item._id.toString()
        );
        let index = allItems.findIndex(
          (el) => el._id.toString() == item._id.toString()
        );

        // let mod_attached = filter(attachedChartItems, (c) => c.itemId.toString() != item._id);

        allItems[index].selected = null;
        allItems[index].type = null;
        // allItems[index]
        // allItems = sortBy(allItems, ['type','lastUpdate.dateTime']);
        this.setState({ charts: mod_chart, linkedItems: allItems, allItems });
      }
    }

    if (type == 2) {
      if (
        (tools.length > 0 &&
          findIndex(tools, (tool) => {
            return item._id.toString() === tool.itemId.toString();
          }) === -1) ||
        tools.length == 0
      ) {
        let obj = {
          itemId: item._id,
          date: new Date(),
          user: this.props.user.profile._id,
          firstName: this.props.user.profile.firstName,
          lastName: this.props.user.profile.lastName,
          type: "OfficeToolkit",
          category: item.category,
          organizationId: this.props.user.profile.organizationId._id,
        };

        let index = allItems.findIndex((el) => el._id == item._id);

        // let result = tools.concat(obj)
        let result = [obj, ...tools];
        item = { ...item, selected: true, type: obj.type };
        allItems[index] = item;

        // if(allItems && allItems.length>0){
        //   allItems.splice(index,1)
        //   allItems.splice(0,0, item)
        // } else {
        //   allItems.push(item)
        // }
        // allItems = sortBy(allItems, ['type','lastUpdate.dateTime']);

        // let attachedItm = {...obj, ...item}
        // attachedChartItems.push(attachedItm)

        let stateObj = { tools: result, allItems };

        if (searchedTerm.length === 0) {
          stateObj = { ...stateObj, linkedItems: allItems };
        }

        this.setState(stateObj);
      } else {
        let mod_tool = filter(
          tools,
          (c) => c.itemId.toString() != item._id.toString()
        );
        let index = allItems.findIndex(
          (el) => el._id.toString() == item._id.toString()
        );

        // let mod_attached = filter(attachedChartItems, (c) => c.itemId.toString() != item._id);

        allItems[index].selected = null;
        allItems[index].type = null;

        // allItems = sortBy(allItems, ['type','lastUpdate.dateTime']);
        this.setState({ tools: mod_tool, linkedItems: allItems, allItems });
      }
    }
  };

  handleSearchQueryChanged = ({ target }) => {
    const { name, value } = target;
    let { allItems, linkedItems } = this.state;
    let list = [];
    linkedItems = allItems;
    if (value.length === 0) {
      list = allItems;
    } else {
      linkedItems = filter(linkedItems, (itm) =>
        itm.name.toLowerCase().includes(value.toLowerCase())
      );
    }
    this.setState({
      linkedItems,
      searchedTerm: value,
    });
  };

  attachTaskItems = () => {
    let {
      isResourceSelect,
      allItems,
      charts,
      tools,
      task_copy,
      attachedChartItems,
      attachedToolItems,
    } = this.state;

    let payload = {
        taskId: task_copy._id,
        type: isResourceSelect,
        data: isResourceSelect == 1 ? charts : tools,
      },
      obj;

    console.log("charts: ", charts);
    axios.post(url.attachItemsTodo, payload).then(({ data }) => {
      let items_data = isResourceSelect == 1 ? charts : tools;

      if (isResourceSelect == 1) {
        obj = {
          isResourceSelect: null,
          task_copy: { ...task_copy, charts: items_data },
          task: { ...task_copy, charts: items_data },
          charts: items_data,
          searchedTerm: "",
          isLinkItemsModal: false,
        };
      } else {
        obj = {
          isResourceSelect: null,
          task_copy: { ...task_copy, tools: items_data },
          task: { ...task_copy, tools: items_data },
          tools: items_data,
          searchedTerm: "",
          isLinkItemsModal: false,
        };
      }
      this.setState(obj);
    });
  };

  removeAttachItems = (item) => {
    let { tools, charts, allItems, task_copy, isResourceSelect } = this.state;
    let payload = {
      taskId: task_copy._id,
      type: isResourceSelect === 1 ? "charts" : "tools",
      itemId: item._id,
      user: this.props.user.profile._id,
      organizationId: this.props.user.profile._id,
    };
    let data = isResourceSelect === 1 ? charts : tools;
    let mod_type = filter(data, function(el) {
      return el.itemId != item._id;
    });
    let index = allItems.findIndex((el) => el._id == item._id);
    allItems[index].selected = null;
    let task = { ...task_copy, [payload.type]: mod_type };
    this.setState({
      [payload.type]: mod_type,
      linkedItems: allItems,
      task_copy: task,
      task,
    });

    axios.post(url.removeItemsTodo, payload).then(({ data }) => {});
  };

  renderRemoveItem = (itm) => {
    let { isResourceSelect, task_copy, allItems } = this.state;
    let isRemoveItem =
      findIndex(task_copy[isResourceSelect == 1 ? "charts" : "tools"], (c) => {
        return c.itemId == itm._id;
      }) > -1;

    if (isRemoveItem) {
      return (
        <span
          className="removeAttachItems"
          onClick={() => this.removeAttachItems(itm)}
        >
          Remove
        </span>
      );
    }
  };

  renderChartsView = () => {
    let { task_copy, isLinkItemsModal } = this.state;
    let charts = task_copy.charts;
    if (charts && charts.length > 0) {
      return (
        <div>
          {!isLinkItemsModal && (
            <LinkedCharts taskId={task_copy._id} linkedCharts={charts} />
          )}
          {this.renderChartsAndResourcesRightColumView()}
        </div>
      );
    } else {
      return (
        <Row>
          {!isLinkItemsModal && (
            <Col>
              <div className="taskNoLinkedItemsContainer task-row-mapping-container">
                <img src={noLinkedChart} className="singleTaskNoItems" />
                There are currently no analytics linked to this action. Link
                charts from any category in the Analytics module to this action
                and begin tracking and/or measuring how this action affects
                various KPIs. Click on the <strong>Link Analytics</strong>{" "}
                button above or{" "}
                <span className="clickHere" onClick={() => this.getItems("C")}>
                  here
                </span>
                .
              </div>
            </Col>
          )}

          <Col>{this.renderChartsAndResourcesRightColumView()}</Col>
        </Row>
      );
    }
  };

  renderToolsView = () => {
    let { task_copy, isLinkItemsModal } = this.state;
    let tools = task_copy.tools;
    if (tools && tools.length > 0) {
      return (
        <div>
          <LinkedTools taskId={task_copy._id} linkedTools={tools} />
          {this.renderChartsAndResourcesRightColumView()}
        </div>
      );
    } else {
      return (
        <Row>
          {!isLinkItemsModal && (
            <Col>
              <div className="taskNoLinkedItemsContainer task-row-mapping-container">
                <img src={noLinkedTools} className="singleTaskNoItems" />
                There are currently no {staticTitles.toolkit_lg} items linked to
                this action. Link items from any catgory in the{" "}
                {staticTitles.toolkit_lg_pl} module to this action that could be
                beneficial. Click on the{" "}
                <strong>Link {staticTitles.toolkit_lg}</strong> button above or{" "}
                <span className="clickHere" onClick={() => this.getItems("T")}>
                  here
                </span>
                .
              </div>
            </Col>
          )}

          <Col>{this.renderChartsAndResourcesRightColumView()}</Col>
        </Row>
      );
    }
  };

  removeGroup = (modelDoc) => {
    let { linkedGrp, selected } = this.state;
    let payload = {
      modelId: modelDoc.modelId,
      modelName: modelDoc.onModel,
      itemType: modelDoc.itemType,
      _id: modelDoc._id,
      // groupIds:isChecked,
      groupId: modelDoc.groupId._id,
    };
    let that = this;
    axios.post(url.removeGrpItem, payload).then(({ data }) => {
      let result = linkedGrp.filter((e) => e._id != modelDoc._id);
      let doc = {
        ...selected,
        ...modelDoc.groupId,
      };
      that.setState({
        isSuccess: true,
        selected: null,
        linkedGrp: result,
        modDoc: doc,
        groupList: [doc, ...this.state.groupList],
        displayItems: result,
        // groupList:
        // isSuccessMsg: 0,
        // selected: {...selected, ...data.data}
      });
    });
  };

  editGroups = (groups) => {
    this.setState({ displayItems: groups });
  };

  viewGroup = (grp) => {
    this.props.history.push(
      `/home/groups/${this.props.user.profile.organizationId._id}/view/${grp}`
    );
  };

  renderGroupsView = () => {
    let { task_copy, displayItems, isGroupModal } = this.state;
    // let groups = task_copy.groups
    console.log("displayItem --- ", displayItems);

    if (isGroupModal) {
      return (
        <AddToGroup
          module_name="SingleTask"
          editGroups={this.editGroups}
          closeGroupModal={this.closeGroupModal}
          modelName={"Task"}
          itemType="action"
          itemId={this.state.task._id}
          isOpen={isGroupModal}
        />
      );
    } else if (displayItems && displayItems.length > 0) {
      return displayItems.map((itm, idx) => {
        let group =
          itm.groupId && typeof itm.groupId == "object" ? itm.groupId : itm;
        let img_url =
          group.bannerImg && group.bannerImg.url
            ? group.bannerImg.url
            : grpBannerImg;
        let date_linked = group.createdAt;
        return (
          <div
            className="single_task_grp_row_itm taskUploadPreviewContainer"
            onClick={() => this.viewGroup(group._id)}
            key={idx}
          >
            <span className={"taskUploadPreviewImg"}>
              <img src={img_url} className="fileUploadSize" />
              <div className="single_task_grp_itm_container_details">
                <div className="single_task_grp_itm_title">{group.name}</div>
                {/* // group.categories.map(e=>{ */}
                {/* return(<div className="single_task_grp_itm_container_categories">
                      {e.name}
                    </div>) */}
                <div className="single_task_grp_itm_container_details_css">
                  {/* Members ({group.members.length}) */}
                  {group.members.length}{" "}
                  {group.members.length > 1 ? "Members" : "Member"}
                </div>
                <div className="single_task_grp_itm_container_details_css">
                  {group.categories.length > 0 ? (
                    <div className="single_task_grp_itm_container_categories">
                      {group.categories[0].name}
                      {group.categories.length > 1
                        ? ` +${group.categories.length} more`
                        : null}
                    </div>
                  ) : (
                    <div className="single_task_grp_itm_container_details_css">
                      No categories for group
                    </div>
                  )}
                </div>
                <div className="single_task_grp_itm_container_details_css">
                  <strong>linked on</strong>{" "}
                  {moment(date_linked).format("MMM Do, YYYY")}
                </div>
              </div>
            </span>
          </div>
        );
      });

      //    <div className="singleTaskToolkitTableContainerBox">
      //    <Table responsive hover className="taskToolkitTable">
      //        <thead>
      //        <tr>
      //          <th>Name</th>
      //          <th>Linked on</th>
      //          {/* <th>Created By</th> */}
      //          <th></th>
      //        </tr>
      //        </thead>
      //      <tbody>
      //        {displayItems.length>0&&displayItems.map( (itm,idx) => {
      //          console.log('itm---')
      //          let img_url = itm.groupId.bannerImg.url
      //        return(
      //          <tr className="linkedToolTable" key={itm._id} >
      //           <td >
      //             <img src={img_url} className="single_task_grp_table_img"/>
      //           {itm.groupId.name?itm.groupId.name:itm.name}
      //           <div className="linkedToolView" onClick={()=>this.viewGroup(itm.groupId)}>(view)</div>
      //           </td>

      //          <td >
      //          {moment(itm.createdAt).format('MMM Do, YYYY')}
      //          </td>
      //          <td>
      //            <span className='flaticon-trash' onClick={()=>this.removeGroup(itm)}/>
      //          </td>
      //        </tr>)})}
      //      </tbody>
      //    </Table>
      //  </div>
      // )
    } else {
      return (
        <div>
          {isGroupModal ? (
            <AddToGroup
              module_name="SingleTask"
              editGroups={this.editGroups}
              closeGroupModal={this.closeGroupModal}
              modelName={"Task"}
              itemType="action"
              itemId={this.state.task._id}
              isOpen={isGroupModal}
            />
          ) : (
            <div className="taskNoLinkedItemsContainer w-40 task-row-mapping-container">
              <img src={noLinkedTools} className="singleTaskNoItems" />
              There are currently no groups linked to this action. Link Groups
              to this action in which you are a member. Click on the{" "}
              <strong>Link Groups</strong> button above or{" "}
              <span className="clickHere" onClick={() => this.getItems("G")}>
                here
              </span>
              .
            </div>
          )}
        </div>
      );
    }
  };

  renderChartsAndResourcesRightColumView = () => {
    let {
      isResourceSelect,
      itemsCount,
      linkedItems,
      searchedTerm,
      isLinkItemsModal,
    } = this.state;

    console.log("itemsCount----", itemsCount);
    if (isLinkItemsModal) {
      return (
        <div>
          <div className="singleTaskModalBody">
            Select {isResourceSelect == 1 ? "chart(s)" : "resources"} to link to
            this action. Currently{" "}
            {itemsCount < 1 || !itemsCount || itemsCount == undefined
              ? 0
              : itemsCount}{" "}
            linked.
          </div>

          <Input
            className="singleTaskItemSearch"
            placeholder="Search by name"
            onChange={this.handleSearchQueryChanged}
            value={searchedTerm}
          />

          {linkedItems && linkedItems.length > 0 ? (
            <div className="divTableBody">
              {linkedItems.map((itm, idx) => {
                return (
                  <span key={itm._id + idx} className="singleTaskLinkItem">
                    <Checkbox
                      className="singleTaskLinkCheckBox"
                      checked={this.isItemLinked(itm, isResourceSelect)}
                      type="checkbox"
                      onClick={() => this.editLinkedItem(itm, isResourceSelect)}
                    />
                    {itm.name}
                  </span>
                );
              })}
            </div>
          ) : null}

          <div
            className="singleTaskModalBtn"
            style={{ padding: "10px 0px 0px 0px" }}
          >
            <Button
              className="profile-modal-save-btn  weeklyWinBtn"
              onClick={() => this.attachTaskItems()}
            >
              <span className="profile-modal-save-btn-txt">
                (Un)Attach
                <span className="ml10 flaticon-tick"></span>
              </span>
            </Button>

            <Button
              className="profile-modal-cancel-btn float-right weeklyWinBtn"
              onClick={() => this.closeActionsModal()}
            >
              <span className="profile-modal-cancel-btn-txt">Cancel</span>
            </Button>
          </div>
        </div>
      );
    }
  };

  chainingEditHandler = (item, chaining) => {
    if (item.type === "subAction" && chaining) {
      this.setState({ subActionId: item._id || item, displayType: 1 });
    }
  };

  goBackParentHandler = (item) => {
    this.setState({ subActionId: item._id || item, displayType: 1 });
  };

  renderSubActions = () => {
    const { task_copy } = this.state;
    return (
      <SubActionsTab
        parentTask={task_copy}
        isModal={true}
        closeCurrentModal={this.props.closeEditModal}
        chainingEditHandler={this.chainingEditHandler}
        onSubActionRemove={this.onSubActionRemove}
        onSubActionAdd={this.onSubActionAdd}
      />
    );
  };

  renderView = (displayType) => {
    if (displayType == 1) {
      return this.renderTask();
    } else if (displayType == 2) {
      return this.renderChartsView();
    } else if (displayType == 3) {
      return this.renderToolsView();
    } else if (displayType == 4) {
      return this.renderUploadsView();
    } else if (displayType == 5) {
      return <div className="px-2">{this.renderGroupsView()}</div>;
    } else if (displayType == 6) {
      return this.renderTaskActivity();
    } else if (displayType == 7) {
      return this.renderSubActions();
    }
  };

  changeViewType = (displayType) => {
    if (displayType == 5) {
      let payload = {
        orgId: this.props.user.profile.organizationId._id,
        itemId: this.state.task._id,
        modelName: "Task",
        itemType: "action",
      };

      axios.post(url.getItemsGroup, payload).then(({ data }) => {
        console.log("group data ----", data.data);
        this.setState({
          // groupList: data.data.groups,
          // itemsCount: data.data.count,
          // linkedGrp: data.data.linkedItems,
          displayItems: data.data.linkedItems,
          isNoGroups: data.data.groups.length == 0 ? true : false,
        });
      });
    }
    this.setState({
      displayType,
      dropdownOpen: false,
    });
  };

  renderDropDownViews = () => {
    let { displayType } = this.state;
    let name =
      displayType == 1
        ? "Overview"
        : displayType == 2
        ? "Analytics"
        : displayType == 3
        ? "Resources"
        : displayType == 4
        ? "Uploads"
        : "Overview";
    return (
      <span
        className={`header-tab-btn ${displayType === 1 && "active"}`}
        onClick={() => this.changeViewType(1)}
      >
        <div className="header-tab-btn-content">
          {/* <div className="header-tab-left-divider"></div> */}
          Overview
        </div>

        {displayType === 1 && <div className="header-tab-bottom-line"></div>}
      </span>
    );
  };

  fileSelectedHandler = (e) => {
    if (e.target.files) {
      let arr = [];
      let fileArr = Array.from(e.target.files).map((file, idx) => {
        let obj = {
          name: file.name,
          type: file.type,
          size: file.size,
          file,
          preview: URL.createObjectURL(file),
          isAccepted: checkUploadType(file.type),
          // img: (<span></span>)
        };
        return uploadPreview(obj);
        //  URL.revokeObjectURL(url)
      });

      let acceptedFiles = fileArr.filter((e) => e.isAccepted == true);
      let rejectedFiles = fileArr.filter((e) => e.isAccepted == false);

      this.setState((prevState) => ({
        setImagesPreview: prevState.setImagesPreview.concat(acceptedFiles),
        rejectedFiles: prevState.rejectedFiles.concat(rejectedFiles),
      }));

      Array.from(e.target.files).map((file) => URL.revokeObjectURL(file));
      // fileArr.map(file=> URL.revokeObjectURL(file))
      // arr.map(file=> URL.revokeObjectURL(file))

      // fileArr.map(file=> URL.revokeObjectURL(file.preview))
    }
  };

  removeImage = (photo) => {
    console.log("remove: ", photo);
    let { setImagesPreview } = this.state;
    let { preview } = photo;
    setImagesPreview.map((el) => URL.revokeObjectURL(el.file));
    let result = setImagesPreview.filter((e) => e.preview != preview);
    URL.revokeObjectURL(preview);
    URL.revokeObjectURL(photo.file);
    console.log("res: ", result);
    this.setState({ setImagesPreview: result });
  };

  renderUploadPreview = (source) => {
    let { rejectedFiles } = this.state;
    // if(rejectedFiles && rejectedFiles.length>0){
    //  source = source.concat(rejectedFiles)
    // }

    return source.map((photo, idx) => {
      let { preview, size } = photo;
      let mb = 1024 * 1024;
      let file_size =
        size >= mb
          ? `${(size / mb).toFixed(2)}mb`
          : `${(size / 1024).toFixed(2)}kb`;
      return (
        <span
          key={idx}
          className={
            photo.isAccepted
              ? "taskUploadPreviewImg"
              : "taskUploadPreviewImg rejectedFilesContainer"
          }
        >
          <img src={preview} className="fileUploadSize" />
          <span
            key={preview + idx}
            onClick={() => this.removeImage(photo)}
            className="removeTaskUpload"
          >
            <span className="flaticon-trash" />
          </span>
          <div className="previewTaskImageText">
            <span className="previewTaskImageTitle">{photo.name}</span>
            <span className="previewTaskImageTitle">{file_size}</span>
            {!photo.isAccepted ? (
              <span className="previewTaskImageTitle">
                The following file will not be uploaded because of its file type
              </span>
            ) : null}
          </div>
        </span>
      );
    });
  };

  uploadAttachments = () => {
    let { setImagesPreview, task_copy } = this.state;

    const formData = new FormData();

    if (setImagesPreview && setImagesPreview.length > 0) {
      Array.from(setImagesPreview).forEach((itm) => {
        formData.append("uploads", itm.file);
      });

      formData.append("taskId", task_copy._id);
      // formData.append('isAttachments', task_copy.attachItems)

      axios
        .post(url.taskUploadFiles, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          // console.log('data---', data.data)
          let result = data.data;
          delete result.parentTask;
          delete result.assignedTo;
          delete result.userId;
          let newTask = { ...task_copy, ...result };
          this.setState({
            task: newTask,
            task_copy: newTask,
            isActionsModal: false,
            isResourceSelect: null,
            isUploadFiles: false,
            setImagesPreview: [],
            rejectedFiles: [],
          });
        });
    } else {
      this.setState({
        uploadFileErr: "No files to Upload",
      });
    }
  };

  updateTaskUploads = (task) => {
    this.setState({
      task,
      task_copy: task,
    });
  };

  renderUploadsView = () => {
    let { task_copy } = this.state;
    console.log("callllll", task_copy);
    if (
      task_copy &&
      task_copy.attachments &&
      task_copy.attachments.length > 0
    ) {
      return (
        <TaskFileUploads
          task_copy={task_copy}
          updateTaskUploads={this.updateTaskUploads}
        />
      );
    } else {
      return (
        <div className="taskNoLinkedItemsContainer w-40 task-row-mapping-container">
          <img src={noAttachments} className="singleTaskNoItems" />
          There are currently no attachments uploaded to this action. Upload any
          external file type - csv/excel, image, pdf, powerpoint, word document,
          etc - to this action to track progress, share thoughts, and more.
          Click on the <strong>Upload Files</strong> button above or{" "}
          <span className="clickHere" onClick={() => this.getItems("U")}>
            here
          </span>
          .
        </div>
      );
    }
  };

  handleClick = (event) => {
    const { target = {} } = event || {};
    target.value = "";
  };

  closeGroupModal = () => {
    this.setState({ isGroupModal: false });
  };

  renderLinkBtn = (displayType) => {
    // rgb(0,107,164)
    let { isGroupModal, isLinkItemsModal } = this.state;
    if (displayType == 2 && isLinkItemsModal != true) {
      return (
        <span
          className="actionsByStatus singleTaskChart single_task_link_item_btn_grp"
          onClick={() => this.getItems("C")}
        >
          <span className="flaticon-clip" /> Link Analytics
        </span>
      );
    } else if (displayType == 3 && isLinkItemsModal != true) {
      return (
        <span
          className="actionsByStatus singleTaskUpload single_task_link_item_btn_grp"
          onClick={() => this.getItems("T")}
        >
          <span className="flaticon-clip" />
          Link Resources
        </span>
      );
    } else if (displayType == 4) {
      return (
        <span
          className="actionsByStatus singleTaskUpload single_task_link_item_btn_grp"
          onClick={() => this.getItems("U")}
        >
          <span className="flaticon-clip" />
          Upload Files
        </span>
      );
    } else if (displayType == 5 && isGroupModal != true) {
      return (
        <span
          className="actionsByStatus singleTaskGroups single_task_link_item_btn_grp"
          onClick={() => this.getItems("G")}
        >
          <span className="flaticon-clip" /> Link Groups
        </span>
      );
    }
  };

  render() {
    let {
      isGroupModal,
      isEditModal,
      setImagesPreview,
      task_copy,
      isUploadFiles,

      attachedChartItems,
      isAnonymous,
      updatedFields,
      removedFields,
      searchedTerm,
      displayType,
      allItems,
      tools,
      charts,
      rejectedFiles,
      isLinkItemsModal,
      isActionsModal,
      isEObj,
      enterpriseObjectives,
      isResourceSelect,
      selectedObjective,
      errorSubmit,
      linkedItems,
      optionsDropdownOpen,
    } = this.state;
    let itemsCount;
    if (isResourceSelect === 1) {
      itemsCount =
        task_copy && task_copy.charts.length ? task_copy.charts.length : 0;
    } else if (isResourceSelect === 2) {
      itemsCount =
        task_copy && task_copy.tools.length ? task_copy.tools.length : 0;
    }
    // {(isAnalytics.status && selectModule) || (!selectModule || selectModule==undefined || selectModule==null)?
    console.log("props----- ", this.props);
    // if(task_copy.userId._id.toString() != currentUser._id.toString()){
    //   if(task_copy.assignedTo && task_copy.assignedTo._id && task_copy.assignedTo._id.toString() == currentUser._id.toString()){

    let all_uploaded_files = setImagesPreview.concat(rejectedFiles);

    const { orgAdmin } = this.props.user.profile;

    if (
      task_copy &&
      task_copy.userId &&
      this.props.user &&
      this.props.user.profile
    ) {
      return (
        <div className="singleActionPageCss">
          <ModalHeader className={"edit-modal-actions"}>
            {!isMobile ? (
              <Row>
                <Col md={11} xs={10} className="title-and-tabs-edit mt-2">
                  {/* <span className="pt-1 ml-3 modal-edit-action-title">
                  {this.props.selectedTask && this.props.selectedTask.title}
                </span> */}

                  <div className="modal-header-tab-wrapper ml-4">
                    {this.renderDropDownViews()}
                    {this.props.user && this.props.user.profile ? (
                      this.props.user.profile._id.toString() ==
                        (task_copy.assignedTo &&
                          task_copy.assignedTo._id &&
                          task_copy.assignedTo._id.toString()) ||
                      this.props.user.profile._id ==
                        task_copy.userId._id.toString() ||
                      this.props.user.profile.role == "Admin" ||
                      this.props.user.profile.orgAdmin ? (
                        <span className="modal-header-tab-wrapper">
                          <span
                            className={`header-tab-btn ${displayType === 2 &&
                              "active singleTaskChart"}`}
                            onClick={() => this.changeViewType(2)}
                          >
                            <div className="header-tab-btn-content">
                              <div className="header-tab-left-divider"></div>
                              {/*<img
                              src={analyticsIcon}
                              height="12px"
                              width={"12px"}
                              className="mr-2"
                            />*/}
                              <BiChart size={"14px"} />
                              Analytics
                            </div>

                            {displayType === 2 && (
                              <div className="header-tab-bottom-line singleTaskChart"></div>
                            )}
                          </span>

                          <span
                            className={`header-tab-btn ${displayType === 5 &&
                              "active singleTaskGroups"}`}
                            onClick={() => this.changeViewType(5)}
                          >
                            <div className="header-tab-btn-content">
                              <div className="header-tab-left-divider"></div>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill={
                                  displayType == 5 ? "#00AC97" : "currentColor"
                                }
                                viewBox="0 0 16 16"
                              >
                                <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"></path>
                              </svg>
                              Groups
                            </div>
                            {displayType === 5 && (
                              <div className="header-tab-bottom-line singleTaskGroups"></div>
                            )}
                          </span>

                          <span
                            className={`header-tab-btn ${displayType === 3 &&
                              "active singleTaskToolkit"}`}
                            onClick={() => this.changeViewType(3)}
                          >
                            <div className="header-tab-btn-content">
                              <div className="header-tab-left-divider"></div>

                              {/*<img
                              src={storyTemplates[4].image}
                              height="12px"
                              width={"12px"}
                              className="mr-1"
                            />*/}
                              <BiBasket size={"14px"} />
                              {staticTitles.toolkit_lg_pl}
                            </div>
                            {displayType === 3 && (
                              <div className="header-tab-bottom-line singleTaskToolkit"></div>
                            )}
                          </span>

                          <span
                            className={`header-tab-btn ${displayType === 4 &&
                              "active singleTaskUpload"}`}
                            onClick={() => this.changeViewType(4)}
                          >
                            {" "}
                            <div className="header-tab-btn-content">
                              <div className="header-tab-left-divider"></div>
                              <BiFileFind size={"14px"} />
                              Files
                            </div>
                            {displayType === 4 && (
                              <div className="header-tab-bottom-line singleTaskUpload"></div>
                            )}
                          </span>

                          {
                            task_copy.type !="subAction" && <span
                            className={`header-tab-btn  ${displayType === 7 &&
                              "active singleTaskLinkedAction"}`}
                            onClick={() => this.changeViewType(7)}
                          >
                            {" "}
                            <div className="header-tab-btn-content">
                              <div className="header-tab-left-divider"></div>
                              <BiLink size={"14px"} />
                              Linked Subactions
                            </div>
                            {displayType === 7 && (
                              <div className="header-tab-bottom-line singleTaskLinkedAction"></div>
                            )}
                          </span>
                          }

                          
                        </span>
                      ) : (
                        <span className="modal-header-tab-wrapper">
                          {[1,2].includes(task_copy.privacy) || (task_copy.parentTask && task_copy.parentTask.item && task_copy.parentTask.item._id && task_copy.parentTask.item.type=="objective") && task_copy.type !="subAction"  ? (
                            <span
                              className={`header-tab-btn ${displayType === 7 &&
                                "active singleTaskUpload"}`}
                              onClick={() => this.changeViewType(7)}
                            >
                              {" "}
                              <div className="header-tab-btn-content">
                                <div className="header-tab-left-divider"></div>
                                <BiLink size={"14px"} />
                                Linked Subactions
                              </div>
                              {displayType === 7 && (
                                <div className="header-tab-bottom-line singleTaskUpload"></div>
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                        </span>
                      )
                    ) : null}
                  </div>
                </Col>
                {this.props.editModalId && (
                  <Col md={1} xs={2} className="px-1">
                    <div className="pt-1 px-2">
                      <Button className="p-1 mx-1" color="light">
                        <BiX
                          size={"26px"}
                          onClick={this.props.closeEditModal}
                        />
                      </Button>
                    </div>
                  </Col>
                )}
              </Row>
            ) : (
              <Row>
                {this.props.editModalId && (
                  <Col xs={2} className="px-1">
                    <div className="text-right pt-1 px-2 cursor-pointer">
                      <Button className="p-1 mx-1" color="transparent">
                        <BiChevronLeft
                          onClick={() => this.props.closeEditModal()}
                          size={"26px"}
                        />
                      </Button>
                    </div>
                  </Col>
                )}
                <Col xs={8} className="title-and-tabs-edit px-1 no-scr-mob">
                  {/* <span className="pt-1 ml-3 modal-edit-action-title">
                   {this.props.selectedTask && this.props.selectedTask.title}
                 </span> */}

                  <div className="modal-header-tab-wrapper ml-4">
                    {this.renderDropDownViews()}
                    {this.props.user && this.props.user.profile ? (
                      this.props.user.profile._id.toString() ==
                        (task_copy.assignedTo &&
                          task_copy.assignedTo._id &&
                          task_copy.assignedTo._id.toString()) ||
                      this.props.user.profile._id ==
                        task_copy.userId._id.toString() ||
                      this.props.user.profile.role == "Admin" ||
                      this.props.user.profile.orgAdmin ? (
                        <span className="modal-header-tab-wrapper">
                          <span
                            className={`header-tab-btn ${displayType === 2 &&
                              "active singleTaskChart"}`}
                            onClick={() => this.changeViewType(2)}
                          >
                            <div className="header-tab-btn-content">
                              <div className="header-tab-left-divider"></div>
                              {/*<img
                               src={analyticsIcon}
                               height="12px"
                               width={"12px"}
                               className="mr-2"
                             />*/}
                              <BiChart size={"14px"} />
                              Analytics
                            </div>

                            {displayType === 2 && (
                              <div className="header-tab-bottom-line singleTaskChart"></div>
                            )}
                          </span>

                          <span
                            className={`header-tab-btn ${displayType === 5 &&
                              "active singleTaskGroups"}`}
                            onClick={() => this.changeViewType(5)}
                          >
                            <div className="header-tab-btn-content">
                              <div className="header-tab-left-divider"></div>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill={
                                  displayType == 5 ? "#00AC97" : "currentColor"
                                }
                                viewBox="0 0 16 16"
                              >
                                <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"></path>
                              </svg>
                              Groups
                            </div>
                            {displayType === 5 && (
                              <div className="header-tab-bottom-line singleTaskGroups"></div>
                            )}
                          </span>

                          <span
                            className={`header-tab-btn ${displayType === 3 &&
                              "active singleTaskToolkit"}`}
                            onClick={() => this.changeViewType(3)}
                          >
                            <div className="header-tab-btn-content">
                              <div className="header-tab-left-divider"></div>

                              {/*<img
                               src={storyTemplates[4].image}
                               height="12px"
                               width={"12px"}
                               className="mr-1"
                             />*/}
                              <BiBasket size={"14px"} />
                              {staticTitles.toolkit_lg_pl}
                            </div>
                            {displayType === 3 && (
                              <div className="header-tab-bottom-line singleTaskToolkit"></div>
                            )}
                          </span>

                          <span
                            className={`header-tab-btn ${displayType === 4 &&
                              "active singleTaskUpload"}`}
                            onClick={() => this.changeViewType(4)}
                          >
                            {" "}
                            <div className="header-tab-btn-content">
                              <div className="header-tab-left-divider"></div>
                              <BiFileFind size={"14px"} />
                              Files
                            </div>
                            {displayType === 4 && (
                              <div className="header-tab-bottom-line singleTaskUpload"></div>
                            )}
                          </span>

                          {/* <span
                            className={`header-tab-btn ${
                              displayType === 6 && "active singleTaskUpload"
                            }`}
                            onClick={() => this.changeViewType(6)}
                          >
                            {" "}
                            <div className="header-tab-btn-content">
                              <div className="header-tab-left-divider"></div>
                              <BiReceipt size={"14px"} />
                              Activity log
                            </div>
                            {displayType === 6 && (
                              <div className="header-tab-bottom-line singleTaskUpload"></div>
                            )}
                          </span> */}
                        </span>
                      ) : null
                    ) : null}
                  </div>
                </Col>

                <Col xs={2}>
                  <Dropdown
                    isOpen={optionsDropdownOpen}
                    toggle={() =>
                      this.setState({
                        optionsDropdownOpen: !optionsDropdownOpen,
                      })
                    }
                    direction="left"
                    className="mt-1"
                  >
                    <DropdownToggle tag="span">
                      <BiDotsVertical size="26px" />
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem>
                        {this.checkUserPermission("isComplete") ? (
                          task_copy.completedDate == undefined ? (
                            <span
                              className="singleTaskCompleteContainer editableTaskField"
                              onClick={() => this.openModalAction(1)}
                            >
                              <span className="singleTaskCompleteTxt">
                                Mark Complete
                              </span>

                              <BiCheck color="green" size="24px" />
                              {/* <Checkbox checked={false} type="checkbox" /> */}
                            </span>
                          ) : (
                            <span
                              className="singleTaskCompleteContainer editableTaskField"
                              onClick={() => this.openModalAction(2)}
                            >
                              <span className="singleTaskCompleteTxt">
                                Mark Incomplete
                              </span>

                              <BiX color="red" size="24px" />
                              {/* <Checkbox checked={true} type="checkbox" /> */}
                            </span>
                          )
                        ) : (
                          <span className="singleTaskCompleteContainer">
                            <span className="singleTaskCompleteTxt">
                              {task_copy.completedDate == undefined
                                ? "Incomplete"
                                : "Completed"}
                            </span>
                          </span>
                        )}
                      </DropdownItem>
                      <DropdownItem divider />
                      <DropdownItem>
                        {task_copy.isDeleted != true ? (
                          this.checkUserPermission("archive") ? (
                            <div
                              className=""
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                              onClick={() => this.openModalAction(3)}
                            >
                              <span className="">Archive</span>
                              <span
                                style={{
                                  color: "#5099DE",
                                  fontSize: "0.8rem",
                                  float: "right",
                                }}
                                className="flaticon-trash"
                              ></span>
                            </div>
                          ) : null
                        ) : this.checkUserPermission("restore") ? (
                          <div
                            className=""
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            onClick={() => this.openModalAction(4)}
                          >
                            <span className="">Restore Action</span>
                            <span
                              style={{
                                color: "#5099DE",
                                fontSize: "0.8rem",
                                float: "right",
                              }}
                              className="flaticon-update"
                            ></span>
                          </div>
                        ) : null}
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </Col>
              </Row>
            )}
          </ModalHeader>

          <ModalBody>
            <div className={`taskContainer col-md-12 p-0`}>
              {/*<div className="singleTaskCategories singleTaskModalBtn">
              {this.renderDropDownViews()}
            </div>*/}

              {this.renderLinkBtn(displayType)}

              <span
                className={`single_task_display_content_container css_${displayType}`}
              >
                {this.renderView(displayType)}
              </span>

              {updatedFields.length || removedFields.length > 0 ? (
                <div className="submitTodoContainer">
                  <Button
                    className="profile-modal-save-btn weeklyWinBtn"
                    onClick={() => this.handleSubmitTodo()}
                    disabled={task_copy.privacy == 2 && !selectedObjective._id}
                  >
                    <span className="profile-modal-save-btn-txt">
                      Save<span className="ml10 flaticon-tick"></span>
                    </span>
                  </Button>
                  <Button
                    className="profile-modal-cancel-btn float-right weeklyWinBtn"
                    onClick={() => this.closeShareModal()}
                  >
                    <span className="profile-modal-cancel-btn-txt">Cancel</span>
                  </Button>
                </div>
              ) : null}
              {errorSubmit != "" ? (
                <span className="taskErrorSubmit">{errorSubmit}</span>
              ) : null}

              <Modal
                isOpen={isUploadFiles !== false ? true : false}
                className="uploadFilesModalContainer single_task_uploadFiles_modal"
              >
                <ModalBody
                  style={{ padding: "30px" }}
                  className="taskUploadFileModal"
                >
                  <div className="singleTaskModalTitle">Upload files</div>

                  <div className="singleTaskModalBody mb0">
                    {/* select files below */}

                    <div>
                      {all_uploaded_files && all_uploaded_files.length > 0 ? (
                        <div className="taskUploadPreviewContainer mb0">
                          {this.renderUploadPreview(all_uploaded_files)}
                        </div>
                      ) : null}
                    </div>

                    {/* {rejectedFiles && rejectedFiles.length>0? 
                          <div className="rejectedFilesContainer">
                            The following files were rejected due to their file type:
                            <div className="rejectedFilesTxtContainer">
                            {rejectedFiles.map( (e,idx) => {
                              let txt = (rejectedFiles.length-1)==idx? `${e.name}.`: `${e.name}, `
                              return <span className="rejectedFilesTxt">{txt}</span>
                            })}
                            </div>
                          </div>
                          :null
                          } */}
                  </div>

                  <div className="singleTaskUploadModalBtn">
                    <label
                      htmlFor="profile-pic-file-input"
                      style={{ marginBottom: "0px" }}
                    >
                      <span className="actionsByStatus singleTaskUpload">
                        <span className="flaticon-upload" />
                        Choose Files
                      </span>
                    </label>
                    <input
                      id="profile-pic-file-input"
                      onClick={this.handleClick}
                      onChange={this.fileSelectedHandler}
                      type="file"
                      multiple
                    />
                  </div>
                  {/* profile-modal-save-btn float-left weeklyWinBtn */}
                  <Button
                    className={
                      setImagesPreview && setImagesPreview.length > 0
                        ? "uploadFilesBtn"
                        : "opacity40 uploadFilesBtn"
                    }
                    onClick={
                      setImagesPreview && setImagesPreview.length > 0
                        ? () => this.uploadAttachments()
                        : null
                    }
                  >
                    <span className="">
                      Upload
                      <span className="ml10 flaticon-tick"></span>
                    </span>
                  </Button>
                  {/* profile-modal-cancel-btn float-right weeklyWinBtn */}
                  <Button
                    className="cancelFilesBtn"
                    onClick={() => this.closeActionsModal()}
                  >
                    <span className="profile-modal-cancel-btn-txt">Cancel</span>
                  </Button>
                </ModalBody>
              </Modal>

              <Modal
                isOpen={isActionsModal !== false ? true : false}
                className={`dashboardArchiveModalContainer createModalContainer ${
                  isActionsModal === "Archive" ? "" : "SuccessHead"
                }`}
              >
                <ModalHeader className="dashboardHeader">
                  <div className="dashboardModalTitle">
                    {isActionsModal} action
                  </div>
                </ModalHeader>
                <ModalBody style={{ padding: "30px" }}>
                  <div className="singleTaskModalBody">
                    Are you sure you wish to continue with this action ?
                  </div>

                  <div
                    className="singleTaskModalBtn"
                    style={{ padding: "10px 0px 0px 0px" }}
                  >
                    <Button
                      className={`profile-modal-save-btn ${isActionsModal} weeklyWinBtn`}
                      onClick={() => this.submitAction()}
                      // disabled={!this.state.isEnterpriseObjectiveSelected}
                    >
                      <span className="profile-modal-save-btn-txt">
                        {isActionsModal}
                        <span className="ml10 flaticon-tick"></span>
                      </span>
                    </Button>

                    <Button
                      className="profile-modal-cancel-btn float-right weeklyWinBtn"
                      onClick={() => this.closeActionsModal()}
                    >
                      <span className="profile-modal-cancel-btn-txt">
                        Cancel
                      </span>
                    </Button>
                  </div>
                </ModalBody>
              </Modal>

              {/* <Modal
                isOpen={isEObj}
                className="ent-obj-link-modal linkEnterpriseObjModal"
              >
                <ModalHeader
                  className="dashboardHeader"
                  charCode="X"
                  toggle={() => this.closeEObjModal()}
                >
                  <div className="dashboardModalTitle">
                    Link Enterprise Objective
                  </div>
                </ModalHeader>

                <ModalBody style={{ padding: "30px" }}>
                  

                  <div className="singleTaskModalBody">
                    <span className="singleTaskModalBodyTxt">
                      Select the Enterprise DEI Objective to link your Action
                      with.
                      {task_copy.parentTask && task_copy.parentTask.item ? (
                        <span>
                          It is currently attached on{" "}
                          <strong>
                            {task_copy.parentTask.item.title} objective.
                          </strong>{" "}
                        </span>
                      ) : null}
                    </span>
                    {enterpriseObjectives && enterpriseObjectives.length > 0 ? (
                      <div className="divTableSingleTask">
                        <div className="divTableBody">
                          {enterpriseObjectives.map((eo, idx) => {
                            return (
                              <span key={eo._id + idx}>
                                <Checkbox
                                  className="singleTaskLinkCheckBox"
                                  checked={
                                    selectedObjective &&
                                    selectedObjective._id === eo._id
                                  }
                                  type="checkbox"
                                  onClick={() => this.addEntObj(eo)}
                                />

                                {eo.title}
                              </span>
                            );
                          })}
                        </div>
                      </div>
                    ) : null}
                    <div className="singleActionAnonymous">
                      <span className="">
                        <Toggle
                          checked={isAnonymous}
                          icons={false}
                          onChange={this.handlePermissionChange}
                        />
                      </span>
                      <span className="permission-value ml10">Anonymous</span>
                    </div>
                  </div>

                  <div
                    className="singleTaskModalBtn"
                    style={{ padding: "10px 0px 0px 0px" }}
                  >
                    <Button
                      className="profile-modal-save-btn weeklyWinBtn"
                      onClick={() => this.setNewEO()}
                      // disabled={!this.state.isEnterpriseObjectiveSelected}
                    >
                      <span className="profile-modal-save-btn-txt">
                        (Un)Attach
                        <span className="ml10 flaticon-tick"></span>
                      </span>
                    </Button>

                    <Button
                      className="profile-modal-cancel-btn float-right weeklyWinBtn"
                      onClick={() => this.closeEObjModal()}
                    >
                      <span className="profile-modal-cancel-btn-txt">
                        Cancel
                      </span>
                    </Button>
                  </div>
                </ModalBody>
              </Modal> */}
            </div>
          </ModalBody>
        </div>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onKpiMasterListFetched: (data) =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(SingleTask, axios)));
